//#region import
import React, { Fragment, createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs, OptionsProjectStatus_2 } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnClearTable, BtnDelete, BtnDeleteTable, BtnDraft, BtnEdit, BtnEditTable, BtnPreview, BtnSave, BtnSend, BtnSendRequest, BtnViewTable } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import { SelectItem } from 'components/Input/Select/SelectItem';
import AccordionPanel from '../components/AccordionPanel';
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import AutoCompleteInTable from 'components/DataGrid/AutoCompleteInTable';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import "../StyleProject.css";
import ChangeOrderCustom from 'components/System/ChangeOrderCustom';
import InputNumberItem, { ConvertNumberFormatterLocale } from 'components/Input/InputNumber';
import { RadioListItem } from 'components/Input/Radio';
import { numberFormatterLocale, parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { useLocation } from 'react-router';
import NumberInputCustom from '../components/NumberInputCustom';
import _ from "lodash";
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Panel9 = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel9,
        setisChangePanel9,
        nProjectSummary,
        setnProjectSummary,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        isChangePlan,
        setisChangePlan,
        nProjectVersionID,
        nLogChangeID,
        ObjCheckSubmitVersion,
        setObjCheckSubmitVersion,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [isError, setisError] = useState(false);
    const [nApproveBudget, setnApproveBudget] = useState(null); //วงเงินทั้งหมดของโครงการตอนอนุมัติ 

    const arrTypeID = OptionsProjectStatus_2;

    useEffect(() => {
        setisEditSecretary((isModeSecretary === true || nLogChangeID !== null) ? false : isPermission);
    }, [isModeSecretary, nLogChangeID]);

    useEffect(() => {
        GetFormInitial();
    }, []);

    useEffect(() => {
        if (nProjectID !== 0 && nLogChangeID !== null) GetFormInitial(); handleGetFormProjectID();
    }, [nProjectID, nLogChangeID]);

    useEffect(() => {
        if (isChangePanel9 === true) GetFormInitial();
    }, [isChangePanel9]);

    useEffect(() => {
        if (nProjectVersionID !== 0) handleGetFormProjectID();
    }, [nProjectVersionID]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectPanel9, { nProjectID: nProjectID }, (result) => {

            setnSectionID(result.nSectionID);

            //#region งบดำเนินงานโครงการ (แผนงาน/กิจกรรม) Operating
            setarrProjectOperating_PlanActivity(result.lstProjectOperating_PlanActivity);
            //#endregion

            //#region งบบริหารโครงการ Manage
            if (result.lstProjectManage_Plan.length > 0) {
                //Plan
                setlstProjectManage_Plan(result.lstProjectManage_Plan);
                setarrProjectManage_Plan(result.lstProjectManage_Plan);
                setDataRowManage_Plan({
                    ...initRows,
                    nDataLength: result.lstProjectManage_Plan.length,
                    arrRows: result.lstProjectManage_Plan,
                });
            }
            if (result.lstProjectManage_Activity.length > 0) {
                //Activity
                setlstProjectManage_Activity(result.lstProjectManage_Activity);
                setarrProjectManage_Activity(result.lstProjectManage_Activity);
                setDataRowManage_Activity({
                    ...initRows,
                    nDataLength: result.lstProjectManage_Activity.length,
                    arrRows: result.lstProjectManage_Activity,
                });
            }
            //#endregion

            // setTimeout(() => {
            //     //#region งบบริหารโครงการ Manage
            //     setnSectionID(result.nSectionID);
            //     if (result.lstProjectManage_Plan.length > 0) {
            //         //Plan
            //         setlstProjectManage_Plan(result.lstProjectManage_Plan);
            //         setarrProjectManage_Plan(result.lstProjectManage_Plan);
            //         setDataRowManage_Plan({
            //             ...initRows,
            //             nDataLength: result.lstProjectManage_Plan.length,
            //             arrRows: result.lstProjectManage_Plan,
            //         });
            //     }
            //     if (result.lstProjectManage_Activity.length > 0) {
            //         //Activity
            //         setlstProjectManage_Activity(result.lstProjectManage_Activity);
            //         setarrProjectManage_Activity(result.lstProjectManage_Activity);
            //         setDataRowManage_Activity({
            //             ...initRows,
            //             nDataLength: result.lstProjectManage_Activity.length,
            //             arrRows: result.lstProjectManage_Activity,
            //         });
            //     }
            //     //#endregion           
            //     //#region งบดำเนินงานโครงการ (แผนงาน/กิจกรรม) Operating
            //     setarrProjectOperating_PlanActivity(result.lstProjectOperating_PlanActivity);
            //     //#endregion
            // }, 3000);
            // handleGetTableProject(dataRow);
            setisChangePanel9(false);

            if (result.isComplete !== null && nProjectID !== 0) setisComplete(result.isComplete); //กรณีโหมดแก้ไขที่ Panel 7 มีเพิ่มหัวข้อมาและมีผลให้ Panel 9 ต้องปรับเป็นบันทึกร่าง เลยต้องเปลี่ยนเลยกรณีที่ isComplete != null
        });
    }

    const handleGetFormProjectID = async () => {
        // DialogFn.BlockUI();
        await AxiosFn.Get(ApiProject.GetFormProjectID_Panel9, { nProjectID: nProjectID, nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID), }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);

            setnApproveBudget(result.objResult.nApproveBudget);

            //#region งบบริหารโครงการ Manage
            setarrProjectManage_Plan(result.objResult.lstProjectManage_Plan);
            setDataRowManage_Plan({
                ...initRows,
                nDataLength: result.objResult.lstProjectManage_Plan.length,
                arrRows: result.objResult.lstProjectManage_Plan,
            });

            setarrProjectManage_Activity(result.objResult.lstProjectManage_Activity);
            setDataRowManage_Activity({
                ...initRows,
                nDataLength: result.objResult.lstProjectManage_Activity.length,
                arrRows: result.objResult.lstProjectManage_Activity,
            });
            //#endregion

            //#region งบดำเนินงานโครงการ (แผนงาน/กิจกรรม) Operating
            setarrProjectOperating_PlanActivity(result.objResult.lstProjectOperating_PlanActivity);
            //#endregion

            //#region รายละเอียดความช่วยเหลือ (ถ้ามี) Help
            form.setValue("isOtherBudget", result.objResult.isOtherBudget ? "Y" : "N");
            form.setValue("sOtherBudgetUnit", result.objResult.sOtherBudgetUnit);

            //#region Manage
            setarrProjectHelp_Manage_Plan(result.objResult.lstProjectHelp_Manage_Plan);
            setDataRowHelp_Manage_Plan({
                ...initRows,
                nDataLength: result.objResult.lstProjectHelp_Manage_Plan.length,
                arrRows: result.objResult.lstProjectHelp_Manage_Plan,
            });

            setarrProjectHelp_Manage_Activity(result.objResult.lstProjectHelp_Manage_Activity);
            setDataRowHelp_Manage_Activity({
                ...initRows,
                nDataLength: result.objResult.lstProjectHelp_Manage_Activity.length,
                arrRows: result.objResult.lstProjectHelp_Manage_Activity,
            });
            //#endregion

            //#region Operating
            setarrProjectHelp_Operating_Plan(result.objResult.lstProjectHelp_Operating_Plan);
            setDataRowHelp_Operating_Plan({
                ...initRows,
                nDataLength: result.objResult.lstProjectHelp_Operating_Plan.length,
                arrRows: result.objResult.lstProjectHelp_Operating_Plan,
            });

            setarrProjectHelp_Operating_Activity(result.objResult.lstProjectHelp_Operating_Activity);
            setDataRowHelp_Operating_Activity({
                ...initRows,
                nDataLength: result.objResult.lstProjectHelp_Operating_Activity.length,
                arrRows: result.objResult.lstProjectHelp_Operating_Activity,
            });
            //#endregion

            //#endregion
        });
    };

    //#region งบบริหารโครงการ Manage
    const [nSectionID, setnSectionID] = useState(null);
    const [lstProjectManage_Plan, setlstProjectManage_Plan] = useState([]);
    const [lstProjectManage_Activity, setlstProjectManage_Activity] = useState([]);

    //#region Plan
    const [nProjectManage_PlanIDEdit, setnProjectManage_PlanIDEdit] = useState(0);
    const [ObjManage_PlanIDEdit, setObjManage_PlanIDEdit] = useState(null);
    const [arrProjectManage_Plan, setarrProjectManage_Plan] = useState([]);
    const [DataRowManage_Plan, setDataRowManage_Plan] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formManage_Plan = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sManage_Plan: null,
        } as any,
    });

    const handleChangeOrder = (nNewOrder, nOldOrder) => {
        let arrManage_Plan = DataRowManage_Plan;
        let arrRowManage_Plan = arrManage_Plan.arrRows;
        let objSelf = arrRowManage_Plan.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowManage_Plan.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowManage_Plan.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowManage_Plan = arrRowManage_Plan.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrManage_Plan.arrRows = [...arrRowManage_Plan];
        setDataRowManage_Plan({ ...arrManage_Plan });
        setarrProjectManage_Plan([...arrRowManage_Plan]);
    };

    const dataColumnManage_Plan: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 100,
            getActions: (item) => {
                return [
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Manage_Plan_" + item.row.sID}
                                id={"btnDelete_Manage_Plan_" + item.row.sID}
                                onClick={() => onDeleteManage_Plan(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!item.row.isBtnDelete || !isPermission || isEditSecretary === false}
                            />
                            <BtnEditOnTable
                                key={"btnEdit_Manage_Plan_" + item.row.sID}
                                id={"btnEdit_Manage_Plan_" + item.row.sID}
                                onClick={() => onEditManage_Plan(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                        :
                        <BtnViewDataOnTable
                            key={"btnView_Manage_Plan_" + item.row.sID}
                            id={"btnView_Manage_Plan_" + item.row.sID}
                            onClick={() => onEditManage_Plan(item.row, EnumStatusMode.View)}
                        // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 120,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                return (
                    <ChangeOrderCustom
                        id={"nOrder_Manage_Plan_" + item.row.sID}
                        item={item.row}
                        value={item.row.nOrder}
                        onChangeOrder={(sID, nOrder) => handleChangeOrder(+nOrder, +item.row.nOrder)}
                        optOrder={new LINQ<any>(arrProjectManage_Plan || []).Where(w => w.nOrder !== 0).OrderBy(o => o.nOrder).Select(function (elem) { return { label: elem.nOrder, value: elem.nOrder, } }).ToArray() ?? []}
                        IsView={false}
                        disabled={!isPermission || isEditSecretary === false}
                    />
                );
            },
        },
        {
            field: "sPlan",
            headerName: "ชื่อแผนงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
    ];

    const onAddManage_Plan = () => {
        let oForm = formManage_Plan.getValues();
        let ObjDuplicate = (arrProjectManage_Plan || []).filter((f) => !f.isDelete && (nProjectManage_PlanIDEdit !== 0 ? f.nID !== nProjectManage_PlanIDEdit : true) && f.sPlan === oForm.sManage_Plan);
        if ((ObjDuplicate || []).length === 0) {
            let nProjectPlanID = 0;
            let dataRow = DataRowManage_Plan;
            let arrPlan = DefaultArrayEmpty(arrProjectManage_Plan);
            let nMaxID = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nOrder) + 1 : 1;
            let isBtnDelete = true;
            if (nProjectManage_PlanIDEdit) {
                arrPlan = arrPlan.filter((f) => f.nID !== nProjectManage_PlanIDEdit);
                nMaxID = nProjectManage_PlanIDEdit;
                let ObjPlan = arrProjectManage_Plan.find((f) => f.nID === nProjectManage_PlanIDEdit);
                nProjectPlanID = ObjPlan?.nProjectPlanID;
                nOrder = ObjPlan?.nOrder;
                isBtnDelete = ObjPlan?.isBtnDelete;
            }
            let obj = {
                isDelete: false,
                isEdit: false,
                sID: nMaxID.toString(),
                nID: nMaxID,
                nProjectPlanID: nProjectPlanID,
                sPlan: oForm.sManage_Plan,
                nOrder: nOrder,
                isBtnDelete: isBtnDelete,
            };

            let result = [...arrPlan, obj];
            // let nOrder = 1;
            // result.forEach(f => f.nOrder = nOrder++);
            // let arrTable = result.filter(f => !f.isDelete);
            let arrTable = new LINQ<any>(result || []).Where(w => !w.isDelete).OrderBy(o => o.nOrder).ToArray();
            setDataRowManage_Plan({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnProjectManage_PlanIDEdit(0);
            setObjManage_PlanIDEdit(null);
            setarrProjectManage_Plan(result);
            onClearFieldManage_Plan();
        }
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldManage_Plan = () => {
        Object.keys(formManage_Plan.getValues()).forEach((key) => {
            formManage_Plan.setValue(key, null);
            formManage_Plan.clearErrors(key);
        });
    };

    const onEditManage_Plan = (ObjData, nModeID: EnumStatusMode) => {
        setnProjectManage_PlanIDEdit(ObjData.nID);
        let ObjPlan = {
            isDelete: ObjData.isDelete,
            isEdit: true,
            sID: ObjData.sID,
            nID: ObjData.nID,
            nProjectPlanID: ObjData.nProjectPlanID,
            sPlan: ObjData.sPlan,
            nOrder: ObjData.nOrder,
            isBtnDelete: ObjData.isBtnDelete,
        };
        setObjManage_PlanIDEdit(ObjPlan);
        formManage_Plan.setValue("sManage_Plan", ObjPlan.sPlan);

        document.getElementById("myDiv_Manage_Plan").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteManage_Plan = (nID, nModeID: EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrPlanData: any[] = arrProjectManage_Plan;
            let result = arrPlanData.filter((f) => f.nID !== nID);
            let arrDelete = arrPlanData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })
            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => {
                f.nOrder = nOrder++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => { });
            setDataRowManage_Plan({
                ...DataRowManage_Plan,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectManage_Plan([...result, ...arrDelete]);
        });
    };

    useEffect(() => {
        let lstProjectPlan = (arrProjectManage_Plan || []).filter(f => !f.isDelete && !f.isBtnDelete);
        let lstnPlanID = lstProjectPlan.map(m => m.nID);
        let lstUpDataActivity = (arrProjectManage_Activity || []).filter(w => !w.isDelete && lstnPlanID.includes(w.nPlanID));
        lstUpDataActivity.forEach(iActivity => {
            let ObjPlan = lstProjectPlan.find(f => !f.isDelete && !f.isBtnDelete && f.nID === iActivity.nPlanID);
            iActivity.ObjPlan = ObjPlan ? {
                nID: ObjPlan.nID,
                nProjectPlanID: ObjPlan.nProjectPlanID,
                sPlan: ObjPlan.sPlan,
                nOrder: ObjPlan.nOrder,
            } : null;
        });
        let arrTable = new LINQ<any>(lstUpDataActivity || []).OrderBy(o => o.ObjPlan.nOrder).ToArray();
        setDataRowManage_Activity({
            ...DataRowManage_Activity,
            nDataLength: arrTable.length,
            arrRows: arrTable,
        });
        setarrProjectManage_Activity(arrTable);
    }, [arrProjectManage_Plan]);

    //#endregion

    //#region Activity
    const [isExpandedManage_Activity, setisExpandedManage_Activity] = useState(true);
    const [nManage_ActivityIDEdit, setnManage_ActivityIDEdit] = useState(0);
    const [ObjManage_ActivityIDEdit, setObjManage_ActivityIDEdit] = useState(null);
    const [arrProjectManage_Activity, setarrProjectManage_Activity] = useState([]);
    const [DataRowManage_Activity, setDataRowManage_Activity] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formManage_Activity = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nManage_PlanID: null,
            sManage_Activity: null,
            nManage_FundBudget: null,
        } as any,
    });

    const onAddManage_Activity = () => {
        let oForm = formManage_Activity.getValues();
        let ObjDuplicate = arrProjectManage_Activity.filter((f) => !f.isDelete && (nManage_ActivityIDEdit !== 0 ? f.nID !== nManage_ActivityIDEdit : true) && f.sActivity === oForm.sManage_Activity);
        if ((ObjDuplicate || []).length === 0) {
            let nManage_PlanID = Convert.StringToInt(oForm.nManage_PlanID);
            let nActivityID = 0;
            let dataRow = DataRowManage_Activity;
            let arrActivity = DefaultArrayEmpty(arrProjectManage_Activity);
            let nMaxID = new LINQ<any>(arrActivity).Any() ? new LINQ<any>(arrActivity).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrActivity).Where(w => w.nPlanID === nManage_PlanID).Any() ? new LINQ<any>(arrActivity).Where(w => w.nPlanID === nManage_PlanID).Max((m) => m.nOrder) + 1 : 1;
            if (nManage_ActivityIDEdit) {
                arrActivity = arrActivity.filter((f) => f.nID !== nManage_ActivityIDEdit);
                nMaxID = nManage_ActivityIDEdit;
                let ObjActivity = arrProjectManage_Activity.find((f) => f.nID === nManage_ActivityIDEdit);
                nActivityID = ObjActivity?.nActivityID;
                nOrder = ObjActivity?.nOrder;
            }
            let ObjPlan = new LINQ<any>(arrProjectManage_Plan || []).FirstOrDefault(w => !w.isDelete && w.nID === oForm.nManage_PlanID); //nID, sPlan: elem.sPlan
            let obj = {
                isDelete: false,
                isEdit: false,
                sID: nMaxID.toString(),
                nNo: nMaxID,
                nID: nMaxID,
                nActivityID: nActivityID,
                sActivity: oForm.sManage_Activity,
                nFundBudget: oForm.nManage_FundBudget === 0 ? 0 : Convert.StringToFloatOrNull(oForm.nManage_FundBudget),
                nPlanID: oForm.nManage_PlanID,
                nOrder: nOrder,
                ObjPlan: ObjPlan ? {
                    nID: ObjPlan.nID,
                    nProjectPlanID: ObjPlan.nProjectPlanID,
                    sPlan: ObjPlan.sPlan,
                    nOrder: ObjPlan.nOrder,
                } : null,
            };

            let result = [...arrActivity, obj];
            let arrTable = new LINQ<any>(result || []).Where(w => !w.isDelete).OrderBy(o => o.nPlanID).ThenBy(o => o.nOrder).ToArray();
            setDataRowManage_Activity({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnManage_ActivityIDEdit(0);
            setObjManage_ActivityIDEdit(null);
            setarrProjectManage_Activity(result);
            onClearFieldManage_Activity();

            let lstnPlanID = arrTable.map(m => m.nPlanID);
            let dataRowPlan = DataRowManage_Plan;
            let arrPlan = DefaultArrayEmpty(DataRowManage_Plan.arrRows);
            arrPlan.filter(f => lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = false; });
            setDataRowManage_Plan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        }
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldManage_Activity = () => {
        Object.keys(formManage_Activity.getValues()).forEach((key) => {
            formManage_Activity.setValue(key, null);
            formManage_Activity.clearErrors(key);
        });
    };

    const onEditManage_Activity = (ObjData, nModeID: EnumStatusMode) => {
        setnManage_ActivityIDEdit(ObjData.nID);
        let ObjActivity = {
            isDelete: ObjData.isDelete,
            isEdit: true,
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nActivityID: ObjData.nActivityID,
            sActivity: ObjData.sActivity,
            nFundBudget: ObjData.nFundBudget,
            nPlanID: ObjData.nPlanID,
            ObjPlan: ObjData.ObjPlan,
            nOrder: ObjData.nOrder,
        };
        setObjManage_ActivityIDEdit(ObjActivity);
        formManage_Activity.setValue("nManage_PlanID", ObjActivity.nPlanID);
        formManage_Activity.setValue("sManage_Activity", ObjActivity.sActivity);
        // formManage_Activity.setValue("nManage_FundBudget", ConvertNumberFormatterLocale(ObjActivity.nFundBudget, 2));
        formManage_Activity.setValue("nManage_FundBudget", ObjActivity.nFundBudget);
        setisExpandedManage_Activity(false);
        // formManage_Activity.reset({
        //     ...formManage_Activity.watch(),
        // });
        document.getElementById("myDiv_Manage_Activity").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteManage_Activity = (ObjData, nModeID: EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrActivityData: any[] = arrProjectManage_Activity;
            let result = arrActivityData.filter((f) => f.nID !== ObjData.nID);
            let arrDelete = arrActivityData.filter((f) => f.nID === ObjData.nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })

            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete && arrDelete.map(m => m.nPlanID).includes(f.nPlanID)).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => { f.nOrder = nOrder++; });

            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => { });

            setDataRowManage_Activity({
                ...DataRowManage_Activity,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            let lstDataProjectActivity = [...result, ...arrDelete];
            setarrProjectManage_Activity([...result, ...arrDelete]);

            let lstnPlanID = lstDataProjectActivity.filter(f => !f.isDelete).map(m => m.nPlanID);
            let dataRowPlan = DataRowManage_Plan;
            let arrPlan = DefaultArrayEmpty(DataRowManage_Plan.arrRows);
            arrPlan.filter(f => !lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = true; });
            setDataRowManage_Plan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        });
    };

    const handleChangeOrder_Manage_Activity = (nNewOrder, nOldOrder, nPlanID) => {
        let arrRowActivityAll = arrProjectManage_Activity.filter(f => f.nPlanID !== nPlanID);
        let arrRowActivity = arrProjectManage_Activity.filter(f => f.nPlanID === nPlanID);
        let objSelf = arrRowActivity.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowActivity.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowActivity.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowActivity = arrRowActivity.slice().sort((a, b) => a.nOrder - b.nOrder);
        setarrProjectManage_Activity([...arrRowActivity, ...arrRowActivityAll]);
    };

    const CallTableManage_Activity = useCallback(() => {
        // let lstDataActivity = arrProjectManage_Activity.filter(f => !f.isDelete) ?? [];
        // let lstDataPlan = new LINQ<any>(lstDataActivity || []).Where(w=> !w.isDelete).Select(s=> s.ObjPlan ).Distinct().ToArray() ?? [];

        let arrManage_Plan = arrProjectManage_Plan;
        let lstDataActivityAll = arrProjectManage_Activity.filter(f => !f.isDelete) ?? [];
        let lstDataPlan = new LINQ<any>(arrManage_Plan).Where(w => lstDataActivityAll.map(m => m.nPlanID).includes(w.nID)).Distinct().OrderBy(o => o.nOrder).ToArray() ?? [];

        return (
            <TableContainer id='table-manage-activity' component={Paper}>
                <Table sx={{ minWidth: 300 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '100px', width: '100px' }}></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '100px', width: '100px' }}>ลำดับ</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '700px', width: '700px' }}>ชื่อกิจกรรม</TableCell>
                        </TableRow>
                    </TableHead>
                    {lstDataPlan.map((iPlan) => {
                        let lstDataActivity = new LINQ<any>(lstDataActivityAll).Where(w => w.nPlanID === iPlan.nID).OrderBy(o => o.nOrder).ToArray() ?? [];
                        return (
                            <TableBody>
                                <TableRow key={`sID_Manage_Plan_${iPlan.nID}`}>
                                    <TableCell className='bg-color' colSpan={3} align="left">{iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                </TableRow>
                                {/* {lstDataActivity.filter(f=> f.nPlanID === iPlan.nID).map((iActivity) => { */}
                                {lstDataActivity.map((iActivity) => {
                                    let lstnOrder = new LINQ<any>(lstDataActivity).Where(w => w.nOrder !== 0 && w.nPlanID === iActivity.nPlanID).OrderBy(o => o.value).Select(function (elem) { return { label: elem.nOrder, value: elem.nOrder, } }).ToArray();
                                    return (
                                        <TableRow key={`sID_Manage_Activity_${iActivity.sID}`}>
                                            <TableCell align="center">
                                                {(!iActivity.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                    <Grid item xs={12} md={12} container spacing={1} key={`Btn_${iActivity.nID}`}>
                                                        <Grid item>
                                                            <BtnDeleteTable
                                                                key={"btnDelete_Manage_Activity_" + iActivity.nID}
                                                                id={"btnDelete_Manage_Activity_" + iActivity.nID}
                                                                onClick={() => onDeleteManage_Activity(iActivity, EnumStatusMode.Delete)}
                                                                IsDisabled={!isPermission || isEditSecretary === false}
                                                                IsCircleWithOutText={true}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <BtnEditTable
                                                                key={"btnEdit_Manage_Activity_" + iActivity.nID}
                                                                id={"btnEdit_Manage_Activity_" + iActivity.nID}
                                                                onClick={() => onEditManage_Activity(iActivity, EnumStatusMode.Edit)}
                                                                IsDisabled={!isPermission || isEditSecretary === false}
                                                                IsCircleWithOutText={true}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <BtnViewTable
                                                        key={"btnPreview_Manage_Activity_" + iActivity.nID}
                                                        id={"btnPreview_Manage_Activity_" + iActivity.nID}
                                                        onClick={() => onEditManage_Activity(iActivity, EnumStatusMode.View)}
                                                        // IsDisabled={!isPermission || isEditSecretary === false}
                                                        IsCircleWithOutText={true}
                                                    />
                                                }
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12} key={"nOrder_Manage_Activity_" + iActivity.sID}>
                                                    <ChangeOrderCustom
                                                        id={"Manage_Activity_nOrder_" + iActivity.sID}
                                                        item={iActivity}
                                                        value={iActivity.nOrder}
                                                        onChangeOrder={(sID, nOrder) => {
                                                            handleChangeOrder_Manage_Activity(+nOrder, +iActivity.nOrder, iActivity.nPlanID)
                                                        }}
                                                        optOrder={lstnOrder ?? []}
                                                        IsView={false}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body2'>{ParseHtml(iActivity.sActivity)}</Typography>
                                                </Grid>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        )
                    })
                    }
                    {lstDataPlan.length === 0 ?
                        <StyledTableRow key={`sID_Manage_Activity`}>
                            <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                        </StyledTableRow>
                        :
                        null
                    }
                </Table>
            </TableContainer>
        );
    }, [arrProjectManage_Activity, isEditSecretary]);
    //#endregion

    //#endregion

    //#region งบดำเนินงานโครงการ (แผนงาน/กิจกรรม) Operating
    const [arrProjectOperating_PlanActivity, setarrProjectOperating_PlanActivity] = useState([]); //ข้อมูลจาก จากการระบุหัวข้อ 7. แผนการดำเนินงาน

    const [isEdit_Operating, setisEdit_Operating] = useState(false);
    const [nOperatingID, setnOperatingID] = useState(0);
    const [arrOperating_PlanActivity, setarrOperating_PlanActivity] = useState([]);

    const formOperating = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nOperating_PlanID: null,
            // sOperating_ActivityDetail: null,
            // sOperating_Budget: null,
        } as any,
    });

    const onAddOperating = () => {
        let _nOperatingID = nOperatingID;
        let _arrOperating_PlanActivity = DefaultArrayEmpty(arrOperating_PlanActivity);
        let _arrProjectOperating_PlanActivity = DefaultArrayEmpty(arrProjectOperating_PlanActivity);
        _arrProjectOperating_PlanActivity.filter(f => f.nProjectPlanID === _nOperatingID).forEach(iPlan => {
            (iPlan.lstProjectPlanActivity || []).forEach(iActivity => {
                let ObjPlanActivity = new LINQ<any>(_arrOperating_PlanActivity || []).FirstOrDefault(w => w.nActivityID === iActivity.nActivityID);
                iActivity.sActivityDetail = ObjPlanActivity?.sActivityDetail ?? null;
                iActivity.nBudget = ObjPlanActivity?.nBudget === 0 ? 0 : Convert.StringToFloatOrNull(ObjPlanActivity?.nBudget);
                iActivity.isUpDate = (ObjPlanActivity?.sActivityDetail) ? true : false; //ObjPlanActivity?.nBudget !== 0 && 
            });
            iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === (iPlan.lstProjectPlanActivity || []).filter(f => f.isUpDate === true).length ? true : false;
        });
        setarrProjectOperating_PlanActivity(_arrProjectOperating_PlanActivity);
        setarrOperating_PlanActivity([]);
        setnOperatingID(0);
        setisEdit_Operating(false);
        onClearFieldOperating();
    };

    // const handleOnChangeOperating = (sInput, nActivityID, sValue) => {
    //     let _nOperatingID = nOperatingID;
    //     let _arrProjectOperating_PlanActivity = arrProjectOperating_PlanActivity;
    //     _arrProjectOperating_PlanActivity.filter(f => f.nProjectPlanID === _nOperatingID).forEach(iPlan => { 
    //         (iPlan.lstProjectPlanActivity || []).filter(f => f.nActivityID === nActivityID).forEach(iActivity => {                 
    //             switch (sInput) {
    //                 case "sOperating_ActivityDetail":
    //                     iActivity.sActivityDetail = sValue;
    //                     iActivity.isUpDate = (sValue && iActivity.nBudget) ? true : false;
    //                     break;
    //                 case "sOperating_Budget":
    //                     iActivity.nBudget = Convert.StringToFloatOrNull(sValue);
    //                     iActivity.isUpDate = (sValue && iActivity.sActivityDetail) ? true : false;
    //                     break;         
    //             }
    //         });
    //     });
    //     setarrProjectOperating_PlanActivity(_arrProjectOperating_PlanActivity);
    // };

    const onClearFieldOperating = () => {
        Object.keys(formOperating.getValues()).forEach((key) => {
            formOperating.setValue(key, null);
            formOperating.clearErrors(key);
        });
        setarrOperating_PlanActivity([]);
    };

    useEffect(() => {
        let nOperating_PlanID = formOperating.getValues("nOperating_PlanID");
        if (nOperating_PlanID !== null) {
            // let ObjDataOperating_PlanActivity = new LINQ<any>(arrProjectOperaาting_PlanActivity ?? []).FirstOrDefault(w=> w.nProjectPlanID === nOperating_PlanID); //.Select(s=> s.lstProjectPlanActivity)     
            // setarrOperating_PlanActivity(lstProjectPlanActivity ?? []);
            // setnOperatingID(ObjDataOperating_PlanActivity?.nProjectPlanID ?? 0);  
            // setisEdit_Operating((ObjDataOperating_PlanActivity?.lstProjectPlanActivity ?? []).filter(f=> f.isUpDate === true).length > 0);

            // let ObjDataOperating_PlanActivity = [...arrProjectOperating_PlanActivity].filter(f => parseInt(f.nProjectPlanID) === parseInt(nOperating_PlanID));
            // let lstProjectPlanActivity = [].concat(...ObjDataOperating_PlanActivity.map(m => m.lstProjectPlanActivity));
            // setarrOperating_PlanActivity(lstProjectPlanActivity ?? []);
            // setnOperatingID(parseInt(nOperating_PlanID));  
            // setisEdit_Operating((lstProjectPlanActivity ?? []).filter(f=> f.isUpDate === true).length > 0);

            // let ObjDataOperating_PlanActivity = [...arrProjectOperating_PlanActivity].filter(f => parseInt(f.nProjectPlanID) === parseInt(nOperating_PlanID));
            // let lstProjectPlanActivityAll = [].concat(...ObjDataOperating_PlanActivity.map(m => m.lstProjectPlanActivity));
            // let lstProjectPlanActivity = Object.assign([], lstProjectPlanActivityAll);
            // setarrOperating_PlanActivity(lstProjectPlanActivity);
            // setnOperatingID(parseInt(nOperating_PlanID));
            // setisEdit_Operating((lstProjectPlanActivity || []).filter(f=> f.isUpDate === true).length > 0);

            let ObjDataOperating_PlanActivity = [...arrProjectOperating_PlanActivity].filter(f => parseInt(f.nProjectPlanID) === parseInt(nOperating_PlanID));
            let lstProjectPlanActivityAll = [].concat(...ObjDataOperating_PlanActivity.map(m => m.lstProjectPlanActivity));
            let lstProjectPlanActivity = _.cloneDeep(lstProjectPlanActivityAll);
            setarrOperating_PlanActivity(lstProjectPlanActivity);
            setnOperatingID(parseInt(nOperating_PlanID));
            setisEdit_Operating((lstProjectPlanActivity || []).filter(f => f.isUpDate === true).length > 0);
            formOperating.reset({
                ...formOperating.watch(),
            });
        }
        else {
            setarrOperating_PlanActivity([]);
            setnOperatingID(0);
            setisEdit_Operating(false);
            onClearFieldOperating();
        }
    }, [formOperating.watch("nOperating_PlanID")]);

    const CallTableOperating = useCallback(() => {
        return (
            <TableContainer id='table-manage-activity' component={Paper}>
                <Table sx={{ minWidth: 400 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '400px', width: '400px' }}>รายละเอียด</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '180px', width: '180px' }}>งบกองทุนฯ (บาท)</TableCell>
                        </TableRow>
                    </TableHead>
                    {(arrOperating_PlanActivity || []).map((iActivity) => {
                        return (
                            <TableBody>
                                <TableRow key={`sID_Operating_Activity_${iActivity.nActivityID}`}>
                                    <TableCell className='bg-color' colSpan={2} align="left">{"กิจกรรมที่ " + iActivity.nOrder + ". " + iActivity.sActivity}</TableCell>
                                </TableRow>
                                <TableRow key={`sID_Operating_Activity_${iActivity.nActivityID}`}>
                                    <TableCell align="left">
                                        {/* <Typography variant='body2'>{ParseHtml(iActivity.sActivityDetail ?? "")}</Typography> */}
                                        <TextAreaItem
                                            id={"sOperating_ActivityDetail_" + iActivity.nActivityID}
                                            name={"sOperating_ActivityDetail_" + iActivity.nActivityID}
                                            label={""} //"รายละเอียด"
                                            placeholder={""} //ระบุรายละเอียดเพิ่มเติม
                                            required={true}
                                            maxLength={500}
                                            row={3}
                                            disabled={!isPermission || isEditSecretary === false}
                                            IsShowMessageError={false}
                                            defaultValue={iActivity.sActivityDetail}
                                            onChange={(e) => {
                                                iActivity.sActivityDetail = e.target.value;
                                                iActivity.isUpDate = (e.target.value && iActivity.nBudget) ? true : false;
                                                // handleOnChangeOperating("sOperating_ActivityDetail", iActivity.nActivityID, e.target.value);
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        {/* <Typography variant='body2'>{formatNumber((iActivity.sActivityDetail === null && iActivity.nBudget === 0 ? "" : iActivity.nBudget), 2)}</Typography> */}
                                        <InputNumberItem
                                            id={"sOperating_Budget_" + iActivity.nActivityID}
                                            name={"sOperating_Budget_" + iActivity.nActivityID}
                                            label={""} //"งบกองทุนฯ (บาท)"
                                            placeholder={""} //ระบุงบประมาณ (บาท)
                                            IsComma={true}
                                            IsAllowScientific={false}
                                            type={"Number"}
                                            ShowDigits={2}
                                            maxDigits={2}
                                            maxInteger={8}
                                            min={0}
                                            endAdornment={"บาท"}
                                            required={true}
                                            disabled={!isPermission || isEditSecretary === false}
                                            // defaultValue={iActivity.nBudget === 0 ? null : iActivity.nBudget}
                                            defaultValue={iActivity.nBudget}
                                            IsShowMessageError={false}
                                            onChange={(e) => {
                                                iActivity.nBudget = Convert.StringToFloatOrNull(e);
                                                iActivity.isUpDate = (e && iActivity.sActivityDetail) ? true : false;
                                                // handleOnChangeOperating("sOperating_Budget", iActivity.nActivityID, e);
                                            }}
                                        />
                                        {/* <NumberInputCustom
                                                id={"sOperating_Budget_" + iActivity.nActivityID}
                                                name={"sOperating_Budget_" + iActivity.nActivityID}
                                                label={""} //"งบกองทุนฯ (บาท)"
                                                placeholder={""} //ระบุงบประมาณ (บาท)
                                                required={true}
                                                IsAllowScientific={false}
                                                maxDigits={2}
                                                ShowDigits={2}
                                                maxInteger={8}
                                                IsCanMinus={false}
                                                IsComma={true}
                                                min={0}
                                                endAdornment={"บาท"}
                                                disabled={!isPermission || isEditSecretary === false}
                                                defaultValue={iActivity.nBudget === 0 ? null : iActivity.nBudget}
                                                // defaultValue={ConvertNumberFormatterLocale(iActivity.nBudget, 2)} 
                                                IsShowMessageError={false}
                                                onChange={(e) => {
                                                    iActivity.nBudget = Convert.StringToFloatOrNull(e);
                                                    iActivity.isUpDate = (e && iActivity.sActivityDetail) ? true : false;
                                                    // handleOnChangeOperating("sOperating_Budget", iActivity.nActivityID, e);
                                                }}
                                            /> */}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    })
                    }
                    {(arrOperating_PlanActivity || []).length === 0 ?
                        <StyledTableRow key={`sID_Operating_Activity`}>
                            <TableCell align="center" colSpan={5}>ไม่พบข้อมูล</TableCell>
                        </StyledTableRow>
                        :
                        null
                    }
                </Table>
            </TableContainer>
        );
    }, [arrOperating_PlanActivity, isEditSecretary]);
    //#endregion

    //#region รายละเอียดความช่วยเหลือ (ถ้ามี) Help

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            isOtherBudget: "Y",
            sOtherBudgetUnit: null,
        } as any,
    });

    //#region Manage
    //#region Plan
    const [nProjectHelp_Manage_PlanIDEdit, setnProjectHelp_Manage_PlanIDEdit] = useState(0);
    const [ObjHelp_Manage_PlanIDEdit, setObjHelp_Manage_PlanIDEdit] = useState(null);
    const [arrProjectHelp_Manage_Plan, setarrProjectHelp_Manage_Plan] = useState([]);
    const [DataRowHelp_Manage_Plan, setDataRowHelp_Manage_Plan] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formHelp_Manage_Plan = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sHelp_Manage_Plan: null,
        } as any,
    });

    const handleChangeOrder_Help_Manage_Plan = (nNewOrder, nOldOrder) => {
        let arrHelp_Manage_Plan = DataRowHelp_Manage_Plan;
        let arrRowHelp_Manage_Plan = arrHelp_Manage_Plan.arrRows;
        let objSelf = arrRowHelp_Manage_Plan.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowHelp_Manage_Plan.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowHelp_Manage_Plan.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowHelp_Manage_Plan = arrRowHelp_Manage_Plan.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrHelp_Manage_Plan.arrRows = [...arrRowHelp_Manage_Plan];
        setDataRowHelp_Manage_Plan({ ...arrHelp_Manage_Plan });
        setarrProjectHelp_Manage_Plan([...arrRowHelp_Manage_Plan]);
    };

    const dataColumnHelp_Manage_Plan: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 100,
            getActions: (item) => {
                return [
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Help_Manage_Plan_" + item.row.sID}
                                id={"btnDelete_Help_Manage_Plan_" + item.row.sID}
                                onClick={() => onDeleteHelp_Manage_Plan(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!item.row.isBtnDelete || !isPermission || isEditSecretary === false}
                            />
                            <BtnEditOnTable
                                key={"btnEdit_Help_Manage_Plan_" + item.row.sID}
                                id={"btnEdit_Help_Manage_Plan_" + item.row.sID}
                                onClick={() => onEditHelp_Manage_Plan(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                        :
                        <BtnViewDataOnTable
                            key={"btnView_Help_Manage_Plan_" + item.row.sID}
                            id={"btnView_Help_Manage_Plan_" + item.row.sID}
                            onClick={() => onEditHelp_Manage_Plan(item.row, EnumStatusMode.View)}
                        // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 120,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                return (
                    <ChangeOrderCustom
                        id={"nOrder_Help_Manage_Plan_" + item.row.sID}
                        item={item.row}
                        value={item.row.nOrder}
                        onChangeOrder={(sID, nOrder) => handleChangeOrder_Help_Manage_Plan(+nOrder, +item.row.nOrder)}
                        optOrder={new LINQ<any>(arrProjectHelp_Manage_Plan || []).Where(w => w.nOrder !== 0).OrderBy(o => o.nOrder).Select(function (elem) { return { label: elem.nOrder, value: elem.nOrder, } }).ToArray() ?? []}
                        IsView={false}
                        disabled={!isPermission || isEditSecretary === false}
                    />
                );
            },
        },
        {
            field: "sPlan",
            headerName: "ชื่อแผนงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
    ];

    const onAddHelp_Manage_Plan = () => {
        let oForm = formHelp_Manage_Plan.getValues();
        let ObjDuplicate = (arrProjectHelp_Manage_Plan || []).filter((f) => !f.isDelete && (nProjectHelp_Manage_PlanIDEdit !== 0 ? f.nID !== nProjectHelp_Manage_PlanIDEdit : true) && f.sPlan === oForm.sHelp_Manage_Plan);
        if ((ObjDuplicate || []).length === 0) {
            let nProjectPlanID = 0;
            let dataRow = DataRowHelp_Manage_Plan;
            let arrPlan = DefaultArrayEmpty(arrProjectHelp_Manage_Plan);
            let nMaxID = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nOrder) + 1 : 1;
            let isBtnDelete = true;
            if (nProjectHelp_Manage_PlanIDEdit) {
                arrPlan = arrPlan.filter((f) => f.nID !== nProjectHelp_Manage_PlanIDEdit);
                nMaxID = nProjectHelp_Manage_PlanIDEdit;
                let ObjPlan = arrProjectHelp_Manage_Plan.find((f) => f.nID === nProjectHelp_Manage_PlanIDEdit);
                nProjectPlanID = ObjPlan?.nProjectPlanID;
                nOrder = ObjPlan?.nOrder;
                isBtnDelete = ObjPlan?.isBtnDelete;
            }
            let obj = {
                isDelete: false,
                isEdit: false,
                sID: nMaxID.toString(),
                nID: nMaxID,
                nProjectPlanID: nProjectPlanID,
                sPlan: oForm.sHelp_Manage_Plan,
                nOrder: nOrder,
                isBtnDelete: isBtnDelete,
            };

            let result = [...arrPlan, obj];
            // let nOrder = 1;
            // result.forEach(f => f.nOrder = nOrder++);
            // let arrTable = result.filter(f => !f.isDelete);
            let arrTable = new LINQ<any>(result || []).Where(w => !w.isDelete).OrderBy(o => o.nOrder).ToArray();
            setDataRowHelp_Manage_Plan({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnProjectHelp_Manage_PlanIDEdit(0);
            setObjHelp_Manage_PlanIDEdit(null);
            setarrProjectHelp_Manage_Plan(result);
            onClearFieldHelp_Manage_Plan();
        }
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldHelp_Manage_Plan = () => {
        Object.keys(formHelp_Manage_Plan.getValues()).forEach((key) => {
            formHelp_Manage_Plan.setValue(key, null);
            formHelp_Manage_Plan.clearErrors(key);
        });
    };

    const onEditHelp_Manage_Plan = (ObjData, nModeID: EnumStatusMode) => {
        setnProjectHelp_Manage_PlanIDEdit(ObjData.nID);
        let ObjPlan = {
            isDelete: ObjData.isDelete,
            isEdit: true,
            sID: ObjData.sID,
            nID: ObjData.nID,
            nProjectPlanID: ObjData.nProjectPlanID,
            sPlan: ObjData.sPlan,
            nOrder: ObjData.nOrder,
            isBtnDelete: ObjData.isBtnDelete,
        };
        setObjHelp_Manage_PlanIDEdit(ObjPlan);
        formHelp_Manage_Plan.setValue("sHelp_Manage_Plan", ObjPlan.sPlan);

        document.getElementById("myDiv_Help_Manage_Plan").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteHelp_Manage_Plan = (nID, nModeID: EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrPlanData: any[] = arrProjectHelp_Manage_Plan;
            let result = arrPlanData.filter((f) => f.nID !== nID);
            let arrDelete = arrPlanData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })
            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => {
                f.nOrder = nOrder++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => { });
            setDataRowHelp_Manage_Plan({
                ...DataRowHelp_Manage_Plan,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectHelp_Manage_Plan([...result, ...arrDelete]);
        });
    };

    useEffect(() => {
        let lstProjectPlan = (arrProjectHelp_Manage_Plan || []).filter(f => !f.isDelete && !f.isBtnDelete);
        let lstnPlanID = lstProjectPlan.map(m => m.nID);
        let lstUpDataActivity = (arrProjectHelp_Manage_Activity || []).filter(w => !w.isDelete && lstnPlanID.includes(w.nPlanID));
        lstUpDataActivity.forEach(iActivity => {
            let ObjPlan = lstProjectPlan.find(f => !f.isDelete && !f.isBtnDelete && f.nID === iActivity.nPlanID);
            iActivity.ObjPlan = ObjPlan ? {
                nID: ObjPlan.nID,
                nProjectPlanID: ObjPlan.nProjectPlanID,
                sPlan: ObjPlan.sPlan,
                nOrder: ObjPlan.nOrder,
            } : null;
        });
        let arrTable = new LINQ<any>(lstUpDataActivity || []).OrderBy(o => o.ObjPlan.nOrder).ToArray();
        setDataRowHelp_Manage_Activity({
            ...DataRowHelp_Manage_Activity,
            nDataLength: arrTable.length,
            arrRows: arrTable,
        });
        setarrProjectHelp_Manage_Activity(arrTable);
    }, [arrProjectHelp_Manage_Plan]);
    //#endregion

    //#region Activity
    const [isExpandedHelp_Manage_Activity, setisExpandedHelp_Manage_Activity] = useState(true);
    const [nHelp_Manage_ActivityIDEdit, setnHelp_Manage_ActivityIDEdit] = useState(0);
    const [ObjHelp_Manage_ActivityIDEdit, setObjHelp_Manage_ActivityIDEdit] = useState(null);
    const [arrProjectHelp_Manage_Activity, setarrProjectHelp_Manage_Activity] = useState([]);
    const [DataRowHelp_Manage_Activity, setDataRowHelp_Manage_Activity] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formHelp_Manage_Activity = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nHelp_Manage_PlanID: null,
            sHelp_Manage_Activity: null,
            nHelp_Manage_FundBudget: null,
        } as any,
    });

    const onAddHelp_Manage_Activity = () => {
        let oForm = formHelp_Manage_Activity.getValues();
        let ObjDuplicate = arrProjectHelp_Manage_Activity.filter((f) => !f.isDelete && (nHelp_Manage_ActivityIDEdit !== 0 ? f.nID !== nHelp_Manage_ActivityIDEdit : true) && f.sActivity === oForm.sHelp_Manage_Activity);
        if ((ObjDuplicate || []).length === 0) {
            let nHelp_Manage_PlanID = Convert.StringToInt(oForm.nHelp_Manage_PlanID);
            let nActivityID = 0;
            let dataRow = DataRowHelp_Manage_Activity;
            let arrActivity = DefaultArrayEmpty(arrProjectHelp_Manage_Activity);
            let nMaxID = new LINQ<any>(arrActivity).Any() ? new LINQ<any>(arrActivity).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrActivity).Where(w => w.nPlanID === nHelp_Manage_PlanID).Any() ? new LINQ<any>(arrActivity).Where(w => w.nPlanID === nHelp_Manage_PlanID).Max((m) => m.nOrder) + 1 : 1;
            if (nHelp_Manage_ActivityIDEdit) {
                arrActivity = arrActivity.filter((f) => f.nID !== nHelp_Manage_ActivityIDEdit);
                nMaxID = nHelp_Manage_ActivityIDEdit;
                let ObjActivity = arrProjectHelp_Manage_Activity.find((f) => f.nID === nHelp_Manage_ActivityIDEdit);
                nActivityID = ObjActivity?.nActivityID;
                nOrder = ObjActivity?.nOrder;
            }
            let ObjPlan = new LINQ<any>(arrProjectHelp_Manage_Plan || []).FirstOrDefault(w => !w.isDelete && w.nID === oForm.nHelp_Manage_PlanID); //nID, sPlan: elem.sPlan
            let obj = {
                isDelete: false,
                isEdit: false,
                sID: nMaxID.toString(),
                nNo: nMaxID,
                nID: nMaxID,
                nActivityID: nActivityID,
                sActivity: oForm.sHelp_Manage_Activity,
                nFundBudget: oForm.nHelp_Manage_FundBudget === 0 ? 0 : Convert.StringToFloatOrNull(oForm.nHelp_Manage_FundBudget),
                nPlanID: oForm.nHelp_Manage_PlanID,
                nOrder: nOrder,
                ObjPlan: ObjPlan ? {
                    nID: ObjPlan.nID,
                    nProjectPlanID: ObjPlan.nProjectPlanID,
                    sPlan: ObjPlan.sPlan,
                    nOrder: ObjPlan.nOrder,
                } : null,
            };

            let result = [...arrActivity, obj];
            let arrTable = new LINQ<any>(result || []).Where(w => !w.isDelete).OrderBy(o => o.nPlanID).ThenBy(o => o.nOrder).ToArray();
            setDataRowHelp_Manage_Activity({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnHelp_Manage_ActivityIDEdit(0);
            setObjHelp_Manage_ActivityIDEdit(null);
            setarrProjectHelp_Manage_Activity(result);
            onClearFieldHelp_Manage_Activity();

            let lstnPlanID = arrTable.map(m => m.nPlanID);
            let dataRowPlan = DataRowHelp_Manage_Plan;
            let arrPlan = DefaultArrayEmpty(DataRowHelp_Manage_Plan.arrRows);
            arrPlan.filter(f => lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = false; });
            setDataRowHelp_Manage_Plan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        }
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldHelp_Manage_Activity = () => {
        Object.keys(formHelp_Manage_Activity.getValues()).forEach((key) => {
            formHelp_Manage_Activity.setValue(key, null);
            formHelp_Manage_Activity.clearErrors(key);
        });
    };

    const onEditHelp_Manage_Activity = (ObjData, nModeID: EnumStatusMode) => {
        setnHelp_Manage_ActivityIDEdit(ObjData.nID);
        let ObjActivity = {
            isDelete: ObjData.isDelete,
            isEdit: true,
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nActivityID: ObjData.nActivityID,
            sActivity: ObjData.sActivity,
            nFundBudget: ObjData.nFundBudget,
            nPlanID: ObjData.nPlanID,
            ObjPlan: ObjData.ObjPlan,
            nOrder: ObjData.nOrder,
        };
        setObjHelp_Manage_ActivityIDEdit(ObjActivity);
        formHelp_Manage_Activity.setValue("nHelp_Manage_PlanID", ObjActivity.nPlanID);
        formHelp_Manage_Activity.setValue("sHelp_Manage_Activity", ObjActivity.sActivity);
        // formHelp_Manage_Activity.setValue("nHelp_Manage_FundBudget", ConvertNumberFormatterLocale(ObjActivity.nFundBudget, 2));
        formHelp_Manage_Activity.setValue("nHelp_Manage_FundBudget", ObjActivity.nFundBudget)
        setisExpandedHelp_Manage_Activity(false);

        document.getElementById("myDiv_Help_Manage_Activity").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteHelp_Manage_Activity = (ObjData, nModeID: EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrActivityData: any[] = arrProjectHelp_Manage_Activity;
            let result = arrActivityData.filter((f) => f.nID !== ObjData.nID);
            let arrDelete = arrActivityData.filter((f) => f.nID === ObjData.nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })

            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete && arrDelete.map(m => m.nPlanID).includes(f.nPlanID)).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => { f.nOrder = nOrder++; });

            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => { });

            setDataRowHelp_Manage_Activity({
                ...DataRowHelp_Manage_Activity,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            let lstDataProjectActivity = [...result, ...arrDelete];
            setarrProjectHelp_Manage_Activity([...result, ...arrDelete]);

            let lstnPlanID = lstDataProjectActivity.filter(f => !f.isDelete).map(m => m.nPlanID);
            let dataRowPlan = DataRowHelp_Manage_Plan;
            let arrPlan = DefaultArrayEmpty(DataRowHelp_Manage_Plan.arrRows);
            arrPlan.filter(f => !lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = true; });
            setDataRowHelp_Manage_Plan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        });
    };

    const handleChangeOrder_Help_Manage_Activity = (nNewOrder, nOldOrder, nPlanID) => {
        let arrRowActivityAll = arrProjectHelp_Manage_Activity.filter(f => f.nPlanID !== nPlanID);
        let arrRowActivity = arrProjectHelp_Manage_Activity.filter(f => f.nPlanID === nPlanID);
        let objSelf = arrRowActivity.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowActivity.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowActivity.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowActivity = arrRowActivity.slice().sort((a, b) => a.nOrder - b.nOrder);
        setarrProjectHelp_Manage_Activity([...arrRowActivity, ...arrRowActivityAll]);
    };

    const CallTableHelp_Manage_Activity = useCallback(() => {
        let arrManage_Plan = arrProjectHelp_Manage_Plan;
        let lstDataActivityAll = (arrProjectHelp_Manage_Activity || []).filter(f => !f.isDelete) ?? [];
        let lstDataPlan = new LINQ<any>(arrManage_Plan).Where(w => lstDataActivityAll.map(m => m.nPlanID).includes(w.nID)).Distinct().OrderBy(o => o.nOrder).ToArray() ?? [];

        return (
            <TableContainer id='table-manage-activity' component={Paper}>
                <Table sx={{ minWidth: 300 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '100px', width: '100px' }}></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>ลำดับ</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '570px', width: '570px' }}>ชื่อกิจกรรม</TableCell>
                        </TableRow>
                    </TableHead>
                    {lstDataPlan.map((iPlan) => {
                        let lstDataActivity = new LINQ<any>(lstDataActivityAll).Where(w => w.nPlanID === iPlan.nID).OrderBy(o => o.nOrder).ToArray() ?? [];
                        return (
                            <TableBody>
                                <TableRow key={`sID_Manage_Plan_${iPlan.nID}`}>
                                    <TableCell className='bg-color' colSpan={3} align="left">{iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                </TableRow>
                                {lstDataActivity.map((iActivity) => {
                                    let lstnOrder = new LINQ<any>(lstDataActivity).Where(w => w.nOrder !== 0 && w.nPlanID === iActivity.nPlanID).OrderBy(o => o.value).Select(function (elem) { return { label: elem.nOrder, value: elem.nOrder, } }).ToArray();
                                    return (
                                        <TableRow key={`sID_Help_Manage_Activity_${iActivity.sID}`}>
                                            <TableCell align="center">
                                                {(!iActivity.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                    <Grid item xs={12} md={12} container spacing={1} key={`Btn_${iActivity.nID}`}>
                                                        <Grid item>
                                                            <BtnDeleteTable
                                                                key={"btnDelete_Help_Manage_Activity_" + iActivity.nID}
                                                                id={"btnDelete_Help_Manage_Activity_" + iActivity.nID}
                                                                onClick={() => onDeleteHelp_Manage_Activity(iActivity, EnumStatusMode.Delete)}
                                                                IsDisabled={!isPermission || isEditSecretary === false}
                                                                IsCircleWithOutText={true}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <BtnEditTable
                                                                key={"btnEdit_Help_Manage_Activity_" + iActivity.nID}
                                                                id={"btnEdit_Help_Manage_Activity_" + iActivity.nID}
                                                                onClick={() => onEditHelp_Manage_Activity(iActivity, EnumStatusMode.Edit)}
                                                                IsDisabled={!isPermission || isEditSecretary === false}
                                                                IsCircleWithOutText={true}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <BtnViewTable
                                                        key={"btnPreview_Help_Manage_Activity_" + iActivity.nID}
                                                        id={"btnPreview_Help_Manage_Activity_" + iActivity.nID}
                                                        onClick={() => onEditHelp_Manage_Activity(iActivity, EnumStatusMode.View)}
                                                        // IsDisabled={!isPermission || isEditSecretary === false}
                                                        IsCircleWithOutText={true}
                                                    />
                                                }
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12} key={"nOrder_Help_Manage_Activity_" + iActivity.sID}>
                                                    <ChangeOrderCustom
                                                        id={"Help_Manage_Activity_nOrder_" + iActivity.sID}
                                                        item={iActivity}
                                                        value={iActivity.nOrder}
                                                        onChangeOrder={(sID, nOrder) => {
                                                            handleChangeOrder_Help_Manage_Activity(+nOrder, +iActivity.nOrder, iActivity.nPlanID)
                                                        }}
                                                        optOrder={lstnOrder ?? []}
                                                        IsView={false}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body2'>{ParseHtml(iActivity.sActivity)}</Typography>
                                                </Grid>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        )
                    })
                    }
                    {lstDataPlan.length === 0 ?
                        <StyledTableRow key={`sID_Help_Manage_Activity`}>
                            <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                        </StyledTableRow>
                        :
                        null
                    }
                </Table>
            </TableContainer>
        );
    }, [arrProjectHelp_Manage_Activity, isEditSecretary]);
    //#endregion
    //#endregion

    //#region Operating
    //#region Plan
    const [nProjectHelp_Operating_PlanIDEdit, setnProjectHelp_Operating_PlanIDEdit] = useState(0);
    const [ObjHelp_Operating_PlanIDEdit, setObjHelp_Operating_PlanIDEdit] = useState(null);
    const [arrProjectHelp_Operating_Plan, setarrProjectHelp_Operating_Plan] = useState([]);
    const [DataRowHelp_Operating_Plan, setDataRowHelp_Operating_Plan] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formHelp_Operating_Plan = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sHelp_Operating_Plan: null,
        } as any,
    });

    const handleChangeOrder_Help_Operating_Plan = (nNewOrder, nOldOrder) => {
        let arrHelp_Operating_Plan = DataRowHelp_Operating_Plan;
        let arrRowHelp_Operating_Plan = arrHelp_Operating_Plan.arrRows;
        let objSelf = arrRowHelp_Operating_Plan.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowHelp_Operating_Plan.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowHelp_Operating_Plan.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowHelp_Operating_Plan = arrRowHelp_Operating_Plan.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrHelp_Operating_Plan.arrRows = [...arrRowHelp_Operating_Plan];
        setDataRowHelp_Operating_Plan({ ...arrHelp_Operating_Plan });
        setarrProjectHelp_Operating_Plan([...arrRowHelp_Operating_Plan]);
    };

    const dataColumnHelp_Operating_Plan: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 100,
            getActions: (item) => {
                return [
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Help_Operating_Plan_" + item.row.sID}
                                id={"btnDelete_Help_Operating_Plan_" + item.row.sID}
                                onClick={() => onDeleteHelp_Operating_Plan(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!item.row.isBtnDelete || !isPermission || isEditSecretary === false}
                            />
                            <BtnEditOnTable
                                key={"btnEdit_Help_Operating_Plan_" + item.row.sID}
                                id={"btnEdit_Help_Operating_Plan_" + item.row.sID}
                                onClick={() => onEditHelp_Operating_Plan(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                        :
                        <BtnViewDataOnTable
                            key={"btnView_Help_Operating_Plan_" + item.row.sID}
                            id={"btnView_Help_Operating_Plan_" + item.row.sID}
                            onClick={() => onEditHelp_Operating_Plan(item.row, EnumStatusMode.View)}
                        // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 120,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                return (
                    <ChangeOrderCustom
                        id={"nOrder_Help_Operating_Plan_" + item.row.sID}
                        item={item.row}
                        value={item.row.nOrder}
                        onChangeOrder={(sID, nOrder) => handleChangeOrder_Help_Operating_Plan(+nOrder, +item.row.nOrder)}
                        optOrder={new LINQ<any>(arrProjectHelp_Operating_Plan || []).Where(w => w.nOrder !== 0).OrderBy(o => o.nOrder).Select(function (elem) { return { label: elem.nOrder, value: elem.nOrder, } }).ToArray() ?? []}
                        IsView={false}
                        disabled={!isPermission || isEditSecretary === false}
                    />
                );
            },
        },
        {
            field: "sPlan",
            headerName: "ชื่อแผนงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
    ];

    const onAddHelp_Operating_Plan = () => {
        let oForm = formHelp_Operating_Plan.getValues();
        let ObjDuplicate = (arrProjectHelp_Operating_Plan || []).filter((f) => !f.isDelete && (nProjectHelp_Operating_PlanIDEdit !== 0 ? f.nID !== nProjectHelp_Operating_PlanIDEdit : true) && f.sPlan === oForm.sHelp_Operating_Plan);
        if ((ObjDuplicate || []).length === 0) {
            let nProjectPlanID = 0;
            let dataRow = DataRowHelp_Operating_Plan;
            let arrPlan = DefaultArrayEmpty(arrProjectHelp_Operating_Plan);
            let nMaxID = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrPlan).Any() ? new LINQ<any>(arrPlan).Max((m) => m.nOrder) + 1 : 1;
            let isBtnDelete = true;
            if (nProjectHelp_Operating_PlanIDEdit) {
                arrPlan = arrPlan.filter((f) => f.nID !== nProjectHelp_Operating_PlanIDEdit);
                nMaxID = nProjectHelp_Operating_PlanIDEdit;
                let ObjPlan = arrProjectHelp_Operating_Plan.find((f) => f.nID === nProjectHelp_Operating_PlanIDEdit);
                nProjectPlanID = ObjPlan?.nProjectPlanID;
                nOrder = ObjPlan?.nOrder;
                isBtnDelete = ObjPlan?.isBtnDelete;
            }
            let obj = {
                isDelete: false,
                isEdit: false,
                sID: nMaxID.toString(),
                nID: nMaxID,
                nProjectPlanID: nProjectPlanID,
                sPlan: oForm.sHelp_Operating_Plan,
                nOrder: nOrder,
                isBtnDelete: isBtnDelete,
            };

            let result = [...arrPlan, obj];
            // let nOrder = 1;
            // result.forEach(f => f.nOrder = nOrder++);
            // let arrTable = result.filter(f => !f.isDelete);
            let arrTable = new LINQ<any>(result || []).Where(w => !w.isDelete).OrderBy(o => o.nOrder).ToArray();
            setDataRowHelp_Operating_Plan({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnProjectHelp_Operating_PlanIDEdit(0);
            setObjHelp_Operating_PlanIDEdit(null);
            setarrProjectHelp_Operating_Plan(result);
            onClearFieldHelp_Operating_Plan();
        }
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldHelp_Operating_Plan = () => {
        Object.keys(formHelp_Operating_Plan.getValues()).forEach((key) => {
            formHelp_Operating_Plan.setValue(key, null);
            formHelp_Operating_Plan.clearErrors(key);
        });
    };

    const onEditHelp_Operating_Plan = (ObjData, nModeID: EnumStatusMode) => {
        setnProjectHelp_Operating_PlanIDEdit(ObjData.nID);
        let ObjPlan = {
            isDelete: ObjData.isDelete,
            isEdit: true,
            sID: ObjData.sID,
            nID: ObjData.nID,
            nProjectPlanID: ObjData.nProjectPlanID,
            sPlan: ObjData.sPlan,
            nOrder: ObjData.nOrder,
            isBtnDelete: ObjData.isBtnDelete,
        };
        setObjHelp_Operating_PlanIDEdit(ObjPlan);
        formHelp_Operating_Plan.setValue("sHelp_Operating_Plan", ObjPlan.sPlan);

        document.getElementById("myDiv_Help_Operating_Plan").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteHelp_Operating_Plan = (nID, nModeID: EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrPlanData: any[] = arrProjectHelp_Operating_Plan;
            let result = arrPlanData.filter((f) => f.nID !== nID);
            let arrDelete = arrPlanData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })
            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => {
                f.nOrder = nOrder++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => { });
            setDataRowHelp_Operating_Plan({
                ...DataRowHelp_Operating_Plan,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectHelp_Operating_Plan([...result, ...arrDelete]);
        });
    };

    useEffect(() => {
        let lstProjectPlan = (arrProjectHelp_Operating_Plan || []).filter(f => !f.isDelete && !f.isBtnDelete);
        let lstnPlanID = lstProjectPlan.map(m => m.nID);
        let lstUpDataActivity = (arrProjectHelp_Operating_Activity || []).filter(w => !w.isDelete && lstnPlanID.includes(w.nPlanID));
        lstUpDataActivity.forEach(iActivity => {
            let ObjPlan = lstProjectPlan.find(f => !f.isDelete && !f.isBtnDelete && f.nID === iActivity.nPlanID);
            iActivity.ObjPlan = ObjPlan ? {
                nID: ObjPlan.nID,
                nProjectPlanID: ObjPlan.nProjectPlanID,
                sPlan: ObjPlan.sPlan,
                nOrder: ObjPlan.nOrder,
            } : null;
        });
        let arrTable = new LINQ<any>(lstUpDataActivity || []).OrderBy(o => o.ObjPlan.nOrder).ToArray();
        setDataRowHelp_Operating_Activity({
            ...DataRowHelp_Operating_Activity,
            nDataLength: arrTable.length,
            arrRows: arrTable,
        });
        setarrProjectHelp_Operating_Activity(arrTable);
    }, [arrProjectHelp_Operating_Plan]);
    //#endregion

    //#region Activity
    const [isExpandedHelp_Operating_Activity, setisExpandedHelp_Operating_Activity] = useState(true);
    const [nHelp_Operating_ActivityIDEdit, setnHelp_Operating_ActivityIDEdit] = useState(0);
    const [ObjHelp_Operating_ActivityIDEdit, setObjHelp_Operating_ActivityIDEdit] = useState(null);
    const [arrProjectHelp_Operating_Activity, setarrProjectHelp_Operating_Activity] = useState([]);
    const [DataRowHelp_Operating_Activity, setDataRowHelp_Operating_Activity] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formHelp_Operating_Activity = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nHelp_Operating_PlanID: null,
            sHelp_Operating_Activity: null,
            nHelp_Operating_FundBudget: null,
        } as any,
    });

    const onAddHelp_Operating_Activity = () => {
        let oForm = formHelp_Operating_Activity.getValues();
        let ObjDuplicate = arrProjectHelp_Operating_Activity.filter((f) => !f.isDelete && (nHelp_Operating_ActivityIDEdit !== 0 ? f.nID !== nHelp_Operating_ActivityIDEdit : true) && f.sActivity === oForm.sHelp_Operating_Activity);
        if ((ObjDuplicate || []).length === 0) {
            let nHelp_Operating_PlanID = Convert.StringToInt(oForm.nHelp_Operating_PlanID);
            let nActivityID = 0;
            let dataRow = DataRowHelp_Operating_Activity;
            let arrActivity = DefaultArrayEmpty(arrProjectHelp_Operating_Activity);
            let nMaxID = new LINQ<any>(arrActivity).Any() ? new LINQ<any>(arrActivity).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrActivity).Where(w => w.nPlanID === nHelp_Operating_PlanID).Any() ? new LINQ<any>(arrActivity).Where(w => w.nPlanID === nHelp_Operating_PlanID).Max((m) => m.nOrder) + 1 : 1;
            if (nHelp_Operating_ActivityIDEdit) {
                arrActivity = arrActivity.filter((f) => f.nID !== nHelp_Operating_ActivityIDEdit);
                nMaxID = nHelp_Operating_ActivityIDEdit;
                let ObjActivity = arrProjectHelp_Operating_Activity.find((f) => f.nID === nHelp_Operating_ActivityIDEdit);
                nActivityID = ObjActivity?.nActivityID;
                nOrder = ObjActivity?.nOrder;
            }
            let ObjPlan = new LINQ<any>(arrProjectHelp_Operating_Plan || []).FirstOrDefault(w => !w.isDelete && w.nID === oForm.nHelp_Operating_PlanID); //nID, sPlan: elem.sPlan
            let obj = {
                isDelete: false,
                isEdit: false,
                sID: nMaxID.toString(),
                nNo: nMaxID,
                nID: nMaxID,
                nActivityID: nActivityID,
                sActivity: oForm.sHelp_Operating_Activity,
                nFundBudget: oForm.nHelp_Operating_FundBudget === 0 ? 0 : Convert.StringToFloatOrNull(oForm.nHelp_Operating_FundBudget),
                nPlanID: oForm.nHelp_Operating_PlanID,
                nOrder: nOrder,
                ObjPlan: ObjPlan ? {
                    nID: ObjPlan.nID,
                    nProjectPlanID: ObjPlan.nProjectPlanID,
                    sPlan: ObjPlan.sPlan,
                    nOrder: ObjPlan.nOrder,
                } : null,
            };

            let result = [...arrActivity, obj];
            let arrTable = new LINQ<any>(result || []).Where(w => !w.isDelete).OrderBy(o => o.nPlanID).ThenBy(o => o.nOrder).ToArray();
            setDataRowHelp_Operating_Activity({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnHelp_Operating_ActivityIDEdit(0);
            setObjHelp_Operating_ActivityIDEdit(null);
            setarrProjectHelp_Operating_Activity(result);
            onClearFieldHelp_Operating_Activity();

            let lstnPlanID = arrTable.map(m => m.nPlanID);
            let dataRowPlan = DataRowHelp_Operating_Plan;
            let arrPlan = DefaultArrayEmpty(DataRowHelp_Operating_Plan.arrRows);
            arrPlan.filter(f => lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = false; });
            setDataRowHelp_Operating_Plan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        }
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldHelp_Operating_Activity = () => {
        Object.keys(formHelp_Operating_Activity.getValues()).forEach((key) => {
            formHelp_Operating_Activity.setValue(key, null);
            formHelp_Operating_Activity.clearErrors(key);
        });
    };

    const onEditHelp_Operating_Activity = (ObjData, nModeID: EnumStatusMode) => {
        setnHelp_Operating_ActivityIDEdit(ObjData.nID);
        let ObjActivity = {
            isDelete: ObjData.isDelete,
            isEdit: true,
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nActivityID: ObjData.nActivityID,
            sActivity: ObjData.sActivity,
            nFundBudget: ObjData.nFundBudget,
            nPlanID: ObjData.nPlanID,
            ObjPlan: ObjData.ObjPlan,
            nOrder: ObjData.nOrder,
        };
        setObjHelp_Operating_ActivityIDEdit(ObjActivity);
        formHelp_Operating_Activity.setValue("nHelp_Operating_PlanID", ObjActivity.nPlanID);
        formHelp_Operating_Activity.setValue("sHelp_Operating_Activity", ObjActivity.sActivity);
        // formHelp_Operating_Activity.setValue("nHelp_Operating_FundBudget", ConvertNumberFormatterLocale(ObjActivity.nFundBudget, 2));
        formHelp_Operating_Activity.setValue("nHelp_Operating_FundBudget", ObjActivity.nFundBudget);
        setisExpandedHelp_Operating_Activity(false);

        document.getElementById("myDiv_Help_Operating_Activity").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteHelp_Operating_Activity = (ObjData, nModeID: EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrActivityData: any[] = arrProjectHelp_Operating_Activity;
            let result = arrActivityData.filter((f) => f.nID !== ObjData.nID);
            let arrDelete = arrActivityData.filter((f) => f.nID === ObjData.nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nOrder = 0;
            })

            //เรียง Order ใหม่
            let nOrder = 1;
            result.filter(f => !f.isDelete && arrDelete.map(m => m.nPlanID).includes(f.nPlanID)).sort((a, b) => a.nOrder - b.nOrder).forEach((f) => { f.nOrder = nOrder++; });

            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => { });

            setDataRowHelp_Operating_Activity({
                ...DataRowHelp_Operating_Activity,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            let lstDataProjectActivity = [...result, ...arrDelete];
            setarrProjectHelp_Operating_Activity([...result, ...arrDelete]);

            let lstnPlanID = lstDataProjectActivity.filter(f => !f.isDelete).map(m => m.nPlanID);
            let dataRowPlan = DataRowHelp_Operating_Plan;
            let arrPlan = DefaultArrayEmpty(DataRowHelp_Operating_Plan.arrRows);
            arrPlan.filter(f => !lstnPlanID.includes(f.nID)).forEach(item => { item.isBtnDelete = true; });
            setDataRowHelp_Operating_Plan({
                ...dataRowPlan,
                nDataLength: arrPlan.length,
                arrRows: arrPlan,
            });
        });
    };

    const handleChangeOrder_Help_Operating_Activity = (nNewOrder, nOldOrder, nPlanID) => {
        let arrRowActivityAll = arrProjectHelp_Operating_Activity.filter(f => f.nPlanID !== nPlanID);
        let arrRowActivity = arrProjectHelp_Operating_Activity.filter(f => f.nPlanID === nPlanID);
        let objSelf = arrRowActivity.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowActivity.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowActivity.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowActivity = arrRowActivity.slice().sort((a, b) => a.nOrder - b.nOrder);
        setarrProjectHelp_Operating_Activity([...arrRowActivity, ...arrRowActivityAll]);
    };

    const CallTableHelp_Operating_Activity = useCallback(() => {
        let arrOperating_Plan = arrProjectHelp_Operating_Plan;
        let lstDataActivityAll = arrProjectHelp_Operating_Activity.filter(f => !f.isDelete) ?? [];
        let lstDataPlan = new LINQ<any>(arrOperating_Plan).Where(w => lstDataActivityAll.map(m => m.nPlanID).includes(w.nID)).Distinct().OrderBy(o => o.nOrder).ToArray() ?? [];

        return (
            <TableContainer id='table-manage-activity' component={Paper}>
                <Table sx={{ minWidth: 300 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '100px', width: '100px' }}></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}>ลำดับ</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '570px', width: '570px' }}>ชื่อกิจกรรม</TableCell>
                        </TableRow>
                    </TableHead>
                    {lstDataPlan.map((iPlan) => {
                        let lstDataActivity = new LINQ<any>(lstDataActivityAll).Where(w => w.nPlanID === iPlan.nID).OrderBy(o => o.nOrder).ToArray() ?? [];
                        return (
                            <TableBody>
                                <TableRow key={`sID_Operating_Plan_${iPlan.nID}`}>
                                    <TableCell className='bg-color' colSpan={3} align="left">{iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                </TableRow>
                                {lstDataActivity.map((iActivity) => {
                                    let lstnOrder = new LINQ<any>(lstDataActivity).Where(w => w.nOrder !== 0 && w.nPlanID === iActivity.nPlanID).OrderBy(o => o.value).Select(function (elem) { return { label: elem.nOrder, value: elem.nOrder, } }).ToArray();
                                    return (
                                        <TableRow key={`sID_Help_Operating_Activity_${iActivity.sID}`}>
                                            <TableCell align="center">
                                                {(!iActivity.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                    <Grid item xs={12} md={12} container spacing={1} key={`Btn_${iActivity.nID}`}>
                                                        <Grid item>
                                                            <BtnDeleteTable
                                                                key={"btnDelete_Help_Operating_Activity_" + iActivity.nID}
                                                                id={"btnDelete_Help_Operating_Activity_" + iActivity.nID}
                                                                onClick={() => onDeleteHelp_Operating_Activity(iActivity, EnumStatusMode.Delete)}
                                                                IsDisabled={!isPermission || isEditSecretary === false}
                                                                IsCircleWithOutText={true}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <BtnEditTable
                                                                key={"btnEdit_Help_Operating_Activity_" + iActivity.nID}
                                                                id={"btnEdit_Help_Operating_Activity_" + iActivity.nID}
                                                                onClick={() => onEditHelp_Operating_Activity(iActivity, EnumStatusMode.Edit)}
                                                                IsDisabled={!isPermission || isEditSecretary === false}
                                                                IsCircleWithOutText={true}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <BtnViewTable
                                                        key={"btnPreview_Help_Operating_Activity_" + iActivity.nID}
                                                        id={"btnPreview_Help_Operating_Activity_" + iActivity.nID}
                                                        onClick={() => onEditHelp_Operating_Activity(iActivity, EnumStatusMode.View)}
                                                        // IsDisabled={!isPermission || isEditSecretary === false}
                                                        IsCircleWithOutText={true}
                                                    />
                                                }
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12} key={"nOrder_Help_Operating_Activity_" + iActivity.sID}>
                                                    <ChangeOrderCustom
                                                        id={"Help_Operating_Activity_nOrder_" + iActivity.sID}
                                                        item={iActivity}
                                                        value={iActivity.nOrder}
                                                        onChangeOrder={(sID, nOrder) => {
                                                            handleChangeOrder_Help_Operating_Activity(+nOrder, +iActivity.nOrder, iActivity.nPlanID)
                                                        }}
                                                        optOrder={lstnOrder ?? []}
                                                        IsView={false}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body2'>{ParseHtml(iActivity.sActivity)}</Typography>
                                                </Grid>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        )
                    })
                    }
                    {lstDataPlan.length === 0 ?
                        <StyledTableRow key={`sID_Help_Operating_Activity`}>
                            <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                        </StyledTableRow>
                        :
                        null
                    }
                </Table>
            </TableContainer>
        );
    }, [arrProjectHelp_Operating_Activity, isEditSecretary]);
    //#endregion
    //#endregion

    //#endregion

    //#region ตารางสรุป Summary
    const [ObjProjectSummary, setObjProjectSummary] = useState(null);

    useEffect(() => {
        onChangeProjectSummary();
    }, [arrProjectManage_Plan, arrProjectManage_Activity, arrProjectOperating_PlanActivity, arrProjectHelp_Manage_Plan, arrProjectHelp_Manage_Activity, arrProjectHelp_Operating_Plan, arrProjectHelp_Operating_Activity]);

    const SetValueSum = (arr) => {
        let v = (arr || []).filter(f => f !== undefined && f !== null);
        if (v.length > 0) {
            let val = new LINQ<any>(v).Sum(s => s);
            return parseFloatCheckValue(val);
        } else {
            return "";
        }
    }

    const onChangeProjectSummary = () => {
        // let nSumBudget_Fund = parseFloatCheckValue(0);

        //#region Manage
        let nSumBudget_Manage = null;
        let _arrProjectManage_PlanActivit = [];
        let _arrProjectManage_Plan = DefaultArrayEmpty(arrProjectManage_Plan); //งบบริหารโครงการ Manage > Plan
        let _arrProjectManage_Activity = DefaultArrayEmpty(arrProjectManage_Activity); //งบบริหารโครงการ Manage > Activity

        _arrProjectManage_Plan.filter(f => !f.isDelete).forEach(iPlan => {
            let arrActivity = [];
            let arrSumBudget_Manage = [];

            _arrProjectManage_Activity.filter(f => f.nPlanID === iPlan.nID).forEach(iActivity => {
                let ObjActivity = {
                    nPlanID: iActivity.nPlanID,
                    nActivityID: iActivity.nActivityID,
                    sActivity: iActivity.sActivity,
                    nFundBudget: iActivity.nFundBudget,
                    nOrder: iActivity.nOrder,
                };
                arrActivity.push(ObjActivity);
                if (parseFloatCheckValue(iActivity.nFundBudget)) arrSumBudget_Manage.push(iActivity.nFundBudget);
            });

            let ObjProjectManage = {
                nProjectPlanID: iPlan.nID,
                sPlan: iPlan.sPlan,
                nOrder: iPlan.nOrder,
                lstActivity: DefaultArrayEmpty(arrActivity),
                nSumBudget: SetValueSum(arrSumBudget_Manage),
            };
            _arrProjectManage_PlanActivit.push(ObjProjectManage);
        });
        nSumBudget_Manage = SetValueSum(_arrProjectManage_PlanActivit.map(m => m.nSumBudget));
        //#endregion

        //#region Operating
        let _arrProjectOperating_PlanActivity = DefaultArrayEmpty(arrProjectOperating_PlanActivity); //งบดำเนินงานโครงการ (แผนงาน/กิจกรรม) Operating
        let nSumBudget_Operating = new LINQ<any>(_arrProjectOperating_PlanActivity || []).Where(w => w.lstProjectPlanActivity.length > 0).Select(o => o.lstProjectPlanActivity).Sum(s => s.nBudget);
        //#endregion

        //#region Help
        let arrSumBudget_Help = [];
        let nSumBudget_Help = null;
        // let _arrProjectHelp_ManageOperating = [];
        let isOtherBudget = form.getValues("isOtherBudget") === "Y" ? true : false;
        let sOtherBudgetUnit = form.getValues("sOtherBudgetUnit");

        //#region Help > Manage
        let nSumBudget_Help_Manage = null;
        let _arrProjectHelp_Manage_PlanActivit = [];
        let _arrProjectHelp_Manage_Plan = DefaultArrayEmpty(arrProjectHelp_Manage_Plan); //รายละเอียดความช่วยเหลือ (ถ้ามี) Help > Manage > Plan
        let _arrProjectHelp_Manage_Activity = DefaultArrayEmpty(arrProjectHelp_Manage_Activity); //รายละเอียดความช่วยเหลือ (ถ้ามี) Help > Manage > Activity

        _arrProjectHelp_Manage_Plan.filter(f => !f.isDelete).forEach(iPlan => {
            let arrActivity = [];
            let arrSumBudget_Help_Manage = [];

            _arrProjectHelp_Manage_Activity.filter(f => f.nPlanID === iPlan.nID).forEach(iActivity => {
                let ObjActivity = {
                    nPlanID: iActivity.nPlanID,
                    nActivityID: iActivity.nActivityID,
                    sActivity: iActivity.sActivity,
                    nFundBudget: iActivity.nFundBudget,
                    nOrder: iActivity.nOrder,
                };
                arrActivity.push(ObjActivity);
                if (parseFloatCheckValue(iActivity.nFundBudget)) arrSumBudget_Help_Manage.push(iActivity.nFundBudget);
            });

            let nSumBudget = SetValueSum(arrSumBudget_Help_Manage);
            let ObjProjectHelp_Manage = {
                nProjectPlanID: iPlan.nID,
                sPlan: iPlan.sPlan,
                nOrder: iPlan.nOrder,
                lstActivity: DefaultArrayEmpty(arrActivity),
                nSumBudget: nSumBudget,
            };
            _arrProjectHelp_Manage_PlanActivit.push(ObjProjectHelp_Manage);
            arrSumBudget_Help.push(nSumBudget);
        });
        //#endregion

        //#region Help > Operating
        let nSumBudget_Help_Operating = null;
        let _arrProjectHelp_Operating_PlanActivit = [];
        let _arrProjectHelp_Operating_Plan = DefaultArrayEmpty(arrProjectHelp_Operating_Plan); //รายละเอียดความช่วยเหลือ (ถ้ามี) Help > Operating > Plan
        let _arrProjectHelp_Operating_Activity = DefaultArrayEmpty(arrProjectHelp_Operating_Activity); //รายละเอียดความช่วยเหลือ (ถ้ามี) Help > Operating > Activity

        _arrProjectHelp_Operating_Plan.filter(f => !f.isDelete).forEach(iPlan => {
            let arrActivity = [];
            let arrSumBudget_Help_Operating = [];

            _arrProjectHelp_Operating_Activity.filter(f => f.nPlanID === iPlan.nID).forEach(iActivity => {
                let ObjActivity = {
                    nPlanID: iActivity.nPlanID,
                    nActivityID: iActivity.nActivityID,
                    sActivity: iActivity.sActivity,
                    nFundBudget: iActivity.nFundBudget,
                    nOrder: iActivity.nOrder,
                };
                arrActivity.push(ObjActivity);
                if (parseFloatCheckValue(iActivity.nFundBudget)) arrSumBudget_Help_Operating.push(iActivity.nFundBudget);
            });

            let nSumBudget = SetValueSum(arrSumBudget_Help_Operating);
            let ObjProjectHelp_Operating = {
                nProjectPlanID: iPlan.nID,
                sPlan: iPlan.sPlan,
                nOrder: iPlan.nOrder,
                lstActivity: DefaultArrayEmpty(arrActivity),
                nSumBudget: nSumBudget,
            };
            _arrProjectHelp_Operating_PlanActivit.push(ObjProjectHelp_Operating);
            arrSumBudget_Help.push(nSumBudget);
        });
        //#endregion

        // _arrProjectHelp_ManageOperating = [..._arrProjectHelp_Manage_PlanActivit, ..._arrProjectHelp_Operating_PlanActivit];
        nSumBudget_Help = SetValueSum(arrSumBudget_Help);
        nSumBudget_Help_Manage = new LINQ<any>(_arrProjectHelp_Manage_PlanActivit || []).Sum(s => parseFloatCheckValue(s.nSumBudget)) ?? null;
        nSumBudget_Help_Operating = new LINQ<any>(_arrProjectHelp_Operating_PlanActivit || []).Sum(s => parseFloatCheckValue(s.nSumBudget)) ?? null;
        //#endregion

        let _ObjProjectSummary = {
            arrProjectManage: DefaultArrayEmpty(_arrProjectManage_PlanActivit),
            nSumBudget_Manage: nSumBudget_Manage,

            arrProjectOperating: DefaultArrayEmpty(_arrProjectOperating_PlanActivity),
            nSumBudget_Operating: nSumBudget_Operating,

            isOtherBudget: isOtherBudget,
            sOtherBudgetUnit: sOtherBudgetUnit,
            arrProjectHelp_Manage: DefaultArrayEmpty(_arrProjectHelp_Manage_PlanActivit),
            nSumBudget_Help_Manage: nSumBudget_Help_Manage,
            arrProjectHelp_Operating: DefaultArrayEmpty(_arrProjectHelp_Operating_PlanActivit),
            nSumBudget_Help_Operating: nSumBudget_Help_Operating,

            nSumBudget_Help: nSumBudget_Help,
            // nSumBudget_Fund: nSumBudget_Fund,
        };
        setObjProjectSummary(_ObjProjectSummary);
    }

    const CallTableSummary = useCallback(() => {
        let isOtherBudget = form.getValues("isOtherBudget") === "Y" ? true : false;
        let sOtherBudgetUnit = form.getValues("sOtherBudgetUnit");
        let arrSumBudget_Operating = [];

        return (
            <TableContainer id='table-summary' component={Paper}>
                <Table sx={{ minWidth: 1000 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '50px', width: '50px' }}></TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '700px', width: '700px' }}>แผนงาน/กิจกรรม/งบประมาณ</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '250px', width: '250px' }}>งบกองทุนฯ (บาท)</TableCell>
                        </TableRow>
                    </TableHead>

                    {/* งบบริหารโครงการ Manage */}
                    <TableBody>
                        <TableRow key={`sID_Manage_H`}>
                            <TableCell className='bg-color1' colSpan={3} align="left">{"งบบริหารโครงการ"}</TableCell>
                        </TableRow>
                        {ObjProjectSummary?.arrProjectManage.length === 0 ?
                            <StyledTableRow key={`sID_Manage_N`}>
                                <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                            </StyledTableRow>
                            :
                            (ObjProjectSummary?.arrProjectManage.map((iPlan) => {
                                return (
                                    <>
                                        <TableRow key={`sID_Operating_Plan_${iPlan.nProjectPlanID}`}>
                                            <TableCell className='bg-color2' colSpan={3} align="left">{"แผนงานที่ " + iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                        </TableRow>
                                        {iPlan.lstActivity.filter(f => f.nPlanID === iPlan.nProjectPlanID).map((iActivity) => {
                                            return (
                                                <TableRow key={`sID_Operating_Activity_${iActivity.nActivityID}`}>
                                                    <TableCell align="center">
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{iPlan.nOrder + ". " + iActivity.nOrder}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{ParseHtml(iActivity.sActivity ?? "")}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Grid item xs={12} md={12}>
                                                            <Typography variant='body2'>{formatNumber(iActivity.nFundBudget, 2)}</Typography>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                        <TableRow key={`sID_Operating_Plan_S_${iPlan.nProjectPlanID}`}>
                                            <TableCell className='bg-color3' colSpan={2} align="center">{"รวมงบแผนงานที่ " + iPlan.nOrder}</TableCell>
                                            <TableCell className='bg-color3' colSpan={1} align="right">{formatNumber(iPlan.nSumBudget, 2)}</TableCell>
                                        </TableRow>
                                    </>
                                )
                            }))
                        }
                        <TableRow key={`sID_Manage_S`}>
                            <TableCell className='bg-color4' colSpan={2} align="center">{"รวมงบบริหารโครงการ"}</TableCell>
                            <TableCell className='bg-color4' colSpan={1} align="right">{formatNumber(ObjProjectSummary?.nSumBudget_Manage, 2)}</TableCell>
                        </TableRow>
                    </TableBody>

                    {/* งบดำเนินโครงการ (แผนงาน/กิจกรรม) Operating */}
                    <TableBody>
                        <TableRow key={`sID_Operating_PlanActivity_H`}>
                            <TableCell className='bg-color1' colSpan={3} align="left">{"งบดำเนินโครงการ"}</TableCell>
                        </TableRow>
                        {ObjProjectSummary?.arrProjectOperating.length === 0 ?
                            <StyledTableRow key={`sID_Operating_PlanActivity_N`}>
                                <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                            </StyledTableRow>
                            :
                            (ObjProjectSummary?.arrProjectOperating.map((iPlan) => {
                                let arrSumBudget_Operating_Plan = [];
                                return (
                                    <>
                                        <TableRow key={`sID_Operating_Plan_${iPlan.nProjectPlanID}`}>
                                            <TableCell className='bg-color2' colSpan={3} align="left">{"แผนงานที่ " + iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                        </TableRow>
                                        {iPlan.lstProjectPlanActivity.length === 0 ?
                                            <StyledTableRow key={`sID_Operating_Activity_N`}>
                                                <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                                            </StyledTableRow>
                                            :
                                            (iPlan.lstProjectPlanActivity.filter(f => f.nProjectPlanID === iPlan.nProjectPlanID).map((iActivity) => {
                                                if (parseFloatCheckValue(iActivity.nBudget)) {
                                                    arrSumBudget_Operating_Plan.push(iActivity.nBudget); arrSumBudget_Operating.push(iActivity.nBudget);
                                                }
                                                return (
                                                    <TableRow key={`sID_Operating_Activity_${iActivity.nActivityID}`}>
                                                        <TableCell align="center">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{iPlan.nOrder + ". " + iActivity.nOrder}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{ParseHtml(iActivity.sActivity ?? "")}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{formatNumber(iActivity.nBudget, 2)}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }))
                                        }
                                        <TableRow key={`sID_Operating_Plan_S_${iPlan.nProjectPlanID}`}>
                                            <TableCell className='bg-color3' colSpan={2} align="center">{"รวมงบแผนงานที่ " + iPlan.nOrder}</TableCell>
                                            <TableCell className='bg-color3' colSpan={1} align="right">{formatNumber(SetValueSum(arrSumBudget_Operating_Plan), 2)}</TableCell>
                                        </TableRow>
                                    </>
                                )
                            }))
                        }
                        <TableRow key={`sID_Operating_PlanActivity_S`}>
                            <TableCell className='bg-color4' colSpan={2} align="center">{"รวมงบดำเนินโครงการ"}</TableCell>
                            {/* <TableCell className='bg-color4' colSpan={1} align="right">{formatNumber(ObjProjectSummary?.nSumBudget_Operating, 2)}</TableCell> */}
                            <TableCell className='bg-color4' colSpan={1} align="right">{formatNumber(SetValueSum(arrSumBudget_Operating), 2)}</TableCell>
                        </TableRow>
                    </TableBody>

                    {/* รายละเอียดความช่วยเหลือจาก Help */}
                    {isOtherBudget && //ObjProjectSummary?.isOtherBudget &&
                        <TableBody>
                            <TableRow key={`sID_Help_H`}>
                                {/* <TableCell className='bg-color5' colSpan={3} align="left">{"รายละเอียดความช่วยเหลือจาก" + (ObjProjectSummary?.sOtherBudgetUnit ? " (" + ObjProjectSummary?.sOtherBudgetUnit + ")" : "")}</TableCell> */}
                                <TableCell className='bg-color5' colSpan={3} align="left">{"รายละเอียดความช่วยเหลือจาก" + (sOtherBudgetUnit ? " (" + sOtherBudgetUnit + ")" : "")}</TableCell>
                            </TableRow>

                            {/* งบบริหารโครงการ Manage */}
                            <TableRow key={`sID_Help_Manage_H`}>
                                <TableCell className='bg-color1' colSpan={3} align="left">{"งบบริหารโครงการ"}</TableCell>
                            </TableRow>
                            {ObjProjectSummary?.arrProjectHelp_Manage.length === 0 ?
                                <StyledTableRow key={`sID_Help_Manage_N`}>
                                    <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                                </StyledTableRow>
                                :
                                (ObjProjectSummary?.arrProjectHelp_Manage.map((iPlan) => {
                                    return (
                                        <>
                                            <TableRow key={`sID_Help_Operating_Plan_${iPlan.nProjectPlanID}`}>
                                                <TableCell className='bg-color2' colSpan={3} align="left">{"แผนงานที่ " + iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                            </TableRow>
                                            {iPlan.lstActivity.filter(f => f.nPlanID === iPlan.nProjectPlanID).map((iActivity) => {
                                                return (
                                                    <TableRow key={`sID_Help_Operating_Activity_${iActivity.nActivityID}`}>
                                                        <TableCell align="center">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{iPlan.nOrder + ". " + iActivity.nOrder}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{ParseHtml(iActivity.sActivity ?? "")}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{formatNumber(iActivity.nFundBudget, 2)}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                            <TableRow key={`sID_Help_Operating_Plan_S_${iPlan.nProjectPlanID}`}>
                                                <TableCell className='bg-color3' colSpan={2} align="center">{"รวมงบแผนงานที่ " + iPlan.nOrder}</TableCell>
                                                <TableCell className='bg-color3' colSpan={1} align="right">{formatNumber(iPlan.nSumBudget, 2)}</TableCell>
                                            </TableRow>
                                        </>
                                    )
                                }))
                            }
                            <TableRow key={`sID_Help_Manage_S`}>
                                <TableCell className='bg-color4' colSpan={2} align="center">{"รวมงบบริหารโครงการ"}</TableCell>
                                <TableCell className='bg-color4' colSpan={1} align="right">{formatNumber(ObjProjectSummary?.nSumBudget_Help_Manage, 2)}</TableCell>
                            </TableRow>

                            {/* งบดำเนินโครงการ (แผนงาน/กิจกรรม) Operating */}
                            <TableRow key={`sID_Help_Operating_H`}>
                                <TableCell className='bg-color1' colSpan={3} align="left">{"งบดำเนินโครงการ"}</TableCell>
                            </TableRow>
                            {ObjProjectSummary?.arrProjectHelp_Operating.length === 0 ?
                                <StyledTableRow key={`sID_Help_Operating_N`}>
                                    <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                                </StyledTableRow>
                                :
                                (ObjProjectSummary?.arrProjectHelp_Operating.map((iPlan) => {
                                    return (
                                        <>
                                            <TableRow key={`sID_Help_Operating_Plan_${iPlan.nProjectPlanID}`}>
                                                <TableCell className='bg-color2' colSpan={3} align="left">{"แผนงานที่ " + iPlan.nOrder + ". " + iPlan.sPlan}</TableCell>
                                            </TableRow>
                                            {iPlan.lstActivity.filter(f => f.nPlanID === iPlan.nProjectPlanID).map((iActivity) => {
                                                return (
                                                    <TableRow key={`sID_Help_Operating_Activity_${iActivity.nActivityID}`}>
                                                        <TableCell align="center">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{iPlan.nOrder + ". " + iActivity.nOrder}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{ParseHtml(iActivity.sActivity ?? "")}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Grid item xs={12} md={12}>
                                                                <Typography variant='body2'>{formatNumber(iActivity.nFundBudget, 2)}</Typography>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                            <TableRow key={`sID_Help_Operating_Plan_S_${iPlan.nProjectPlanID}`}>
                                                <TableCell className='bg-color3' colSpan={2} align="center">{"รวมงบแผนงานที่ " + iPlan.nOrder}</TableCell>
                                                <TableCell className='bg-color3' colSpan={1} align="right">{formatNumber(iPlan.nSumBudget, 2)}</TableCell>
                                            </TableRow>
                                        </>
                                    )
                                }))
                            }
                            <TableRow key={`sID_Help_Operating_S`}>
                                <TableCell className='bg-color4' colSpan={2} align="center">{"รวมงบดำเนินโครงการ"}</TableCell>
                                <TableCell className='bg-color4' colSpan={1} align="right">{formatNumber(ObjProjectSummary?.nSumBudget_Help_Operating, 2)}</TableCell>
                            </TableRow>

                            <TableRow key={`sID_Help_S`}>
                                <TableCell className='bg-color5' colSpan={2} align="center">{"งบสนับสนุนจากหน่วยงานอื่น (บาท)"}</TableCell>
                                <TableCell className='bg-color5' colSpan={1} align="right">{formatNumber(ObjProjectSummary?.nSumBudget_Help, 2)}</TableCell>
                            </TableRow>
                        </TableBody>
                    }

                    {/* สรุปยอด */}
                    <TableBody>
                        <TableRow key={`sID_Summary_All`}>
                            <TableCell className='bg-color6' colSpan={2} align="center">{"รวมงบประมาณที่ได้รับการสนับสนุนทั้งหมด (บาท)"}</TableCell>
                            <TableCell className='bg-color6' colSpan={1} align="right">{formatNumber((parseFloatCheckValue(ObjProjectSummary?.nSumBudget_Manage) + parseFloatCheckValue(SetValueSum(arrSumBudget_Operating)) + parseFloatCheckValue(ObjProjectSummary?.nSumBudget_Help)), 2)}</TableCell>
                        </TableRow>
                        <TableRow key={`sID_Summary_All_Fund`}>
                            <TableCell className='bg-color7' colSpan={2} align="center">{"รวมงบประมาณที่ขอรับการสนับสนุนจากกองทุนฯ (บาท)"}</TableCell>
                            <TableCell className='bg-color7' colSpan={1} align="right">{GetSummaryAll(ObjProjectSummary?.nSumBudget_Manage, arrSumBudget_Operating)}</TableCell>
                        </TableRow>
                    </TableBody>

                </Table>
            </TableContainer>
        );
    }, [ObjProjectSummary]);

    const GetSummaryAll = (nSumBudget_Manage, arrSumBudget_Operating) => {
        let nSumAll = (parseFloatCheckValue(nSumBudget_Manage) + parseFloatCheckValue(SetValueSum(arrSumBudget_Operating)));
        setnProjectSummary(nSumAll);
        return formatNumber(nSumAll, 2);
    }

    useEffect(() => {
        if (nApproveBudget !== null && nStatusID === EnumProjectStatusID.nStatusID_11 && nLogChangeID !== null) //วงเงินทั้งหมดของโครงการตอนอนุมัติ 
        {
            if (nProjectSummary > nApproveBudget) { //ไม่ให้ เกินงบ ที่ถูกอนุมัติ และ สามารถน้อยกว่า ได้
                setisError(true);
                DialogFn.Warning("ไม่สามารถเพิ่มงบประมาณเกิน " + formatNumber(nApproveBudget, 2) + "บาท ที่โครงการเคยถูกอนุมัติไปแล้วแต่สามารถระบุเงินน้อยกว่าได้");
            } else {
                setisError(false);
            }
        }
        else {
            //มาตรา 40(3) ต้องดักวงเงินไม่เกิน 2 ล้าน
            if (nSectionID === 37 && nProjectSummary > 2000000) {
                setisError(true);
                DialogFn.Warning("โครงการตาม มาตรา 40(3) จะต้องเป็นโครงการที่มีวงเงินไม่เกิน 2,000,000 บาท (สองล้านบาทถ้วน)");
            } else {
                setisError(false);
            }
        }
    }, [nProjectSummary]);
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        let oForm = form.getValues();
        let isOtherBudget = oForm.isOtherBudget === "Y" ? true : false;

        if (nModeID === EnumSaveModeProject.Submit) {
            if (arrProjectManage_Plan.filter(f => !f.isDelet).length === 0) {
                return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ ในหัวข้อ งบบริหารโครงการ : กำหนดแผนงาน");
            }
            if (arrProjectManage_Activity.filter(f => !f.isDelet).length === 0) {
                return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ ในหัวข้อ งบบริหารโครงการ : กำหนดกิจกรรม");
            }
            if (arrProjectManage_Plan.filter(f => !f.isDelete && f.isBtnDelete).length > 0) { //ต้องมีกิจกรรมในทุกแผนงานที่เพิ่มมาทั้งหมด
                return DialogFn.Warning("กรุณาเพิ่มข้อมูลกิจกรรมให้ครบทุกแผนงาน ในหัวข้อ งบบริหารโครงการ : กำหนดกิจกรรม");
            }
            if (arrProjectOperating_PlanActivity.filter(f => !f.isDelete && f.isSuccess === false).length > 0) {
                return DialogFn.Warning("กรุณาเพิ่มข้อมูลแผนงานให้ครบทุกแผนงาน ในหัวข้อ งบดำเนินงานโครงการ (แผนงาน/กิจกรรม)");
            }

            if (isOtherBudget) //ช่วยเหลือ (ถ้ามี)
            {
                if (arrProjectHelp_Manage_Plan.filter(f => !f.isDelete && f.isBtnDelete).length > 0) {
                    return DialogFn.Warning("กรุณาเพิ่มข้อมูลแผนงานให้ครบทุกแผนงาน ในหัวข้อ รายละเอียดความช่วยเหลือ (ถ้ามี) : งบบริหารโครงการ ส่วน กำหนดแผนงาน");
                }
                if (arrProjectHelp_Operating_Plan.filter(f => !f.isDelete && f.isBtnDelete).length > 0) {
                    return DialogFn.Warning("กรุณาเพิ่มข้อมูลแผนงานให้ครบทุกแผนงาน ในหัวข้อ รายละเอียดความช่วยเหลือ (ถ้ามี) : งบดำเนินงานโครงการ ส่วน กำหนดแผนงาน");
                }
            }
        }

        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel9,
            isFastTrack: isFastTrack,

            //งบบริหารโครงการ Manage
            lstProjectManage_Plan: arrProjectManage_Plan ?? [],
            lstProjectManage_Activity: arrProjectManage_Activity ?? [],

            //งบดำเนินงานโครงการ (แผนงาน/กิจกรรม) Operating
            lstProjectOperating_PlanActivity: arrProjectOperating_PlanActivity ?? [],

            //รายละเอียดความช่วยเหลือ (ถ้ามี) Help
            isOtherBudget: isOtherBudget,
            sOtherBudgetUnit: isOtherBudget ? oForm.sOtherBudgetUnit : null,
            lstProjectHelp_Manage_Plan: isOtherBudget ? arrProjectHelp_Manage_Plan : [],
            lstProjectHelp_Manage_Activity: isOtherBudget ? arrProjectHelp_Manage_Activity : [],
            lstProjectHelp_Operating_Plan: isOtherBudget ? arrProjectHelp_Operating_Plan : [],
            lstProjectHelp_Operating_Activity: isOtherBudget ? arrProjectHelp_Operating_Activity : [],

            nProjectBudget: nProjectSummary, //งบประมาณโครงการทั้งหมด ไม่รวม ช่วยเหลือ
            sLocation: location.pathname,
        };

        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
            ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent)
            : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
                DialogFn.BlockUI();
                AxiosFn.Post(ApiProject.SaveProjectPanel9, param, (result) => {
                    DialogFn.UnBlockUI();
                    if (result.nStatusCode === APIStatusCode.Success) {
                        DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                            setnProjectID(result.objResult?.nProjectID);
                            setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                            // setarrisEditPanel({nPanelID: 9, isEdit: false});
                            setisSubmit(isSubmit === true ? false : true);
                            setisChangePlan(true);
                            if (isEditSecretary && isModeSecretary === true) setisEditSecretary(false);

                            if (nModeID === EnumSaveModeProject.Submit && nStatusID !== EnumProjectStatusID.nStatusID_0) setisCheck(true);
                        });
                    } else {
                        DialogFn.Warning(result.sMessage);
                    }
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
    };

    //#region โหมดแก้ไข เช็คเงื่อนไขกรณีข้อมูลที่อยู่ บันทึกพร้อมส่ง และมีการแก้ข้อมูลไป และมีความสัมพันธ์ Error ของ (WorkPlan 2/1 || SpendingPlan 2/2)
    const [isCheck, setisCheck] = useState(false);
    const [isCheckError, setIsCheckError] = useState(false);

    useEffect(() => {
        if (isChangePlan === false && isCheck === true) {
            document.getElementById("btnCheck_SpendingPlan_ChangeStatus").click(); setIsCheckError(true);
        }
    }, [isChangePlan, isCheck]);

    useEffect(() => {
        if (isCheckError === true && ObjCheckSubmitVersion?.isSpendingPlan === true) {
            setisCheck(false);
            handleCheckPlan();
            setObjCheckSubmitVersion({
                isPanel9: false,
                sWarningPanel9: null,
                isWorkPlan: false,
                sWarningWorkPlan: null,
                isSpendingPlan: false,
                sWarningSpendingPlan: null,
            }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
            setIsCheckError(false);
        }
    }, [isCheckError, ObjCheckSubmitVersion]);

    const handleCheckPlan = () => {
        let param = {
            nProjectID: nProjectID,
            nPanelID: EnumProjectPanel.Panel9,
            isComplete_SpendingPlan: (ObjCheckSubmitVersion?.sWarningSpendingPlan === null || ObjCheckSubmitVersion?.sWarningSpendingPlan === "") ? true : false,
            sMessagePanel: (ObjCheckSubmitVersion?.sWarningSpendingPlan ?? ""),
        };
        AxiosFn.Post(ApiProject.SaveProjectCheckPlan, param, (result) => {
            if (result.nStatusCode === APIStatusCode.Warning) {
                DialogFn.Warning(result.sMessage);
            }
            setisChangePlan(true);
        });
    }
    //#endregion

    const CheckSubmitProjectChangeStatus = () => { //ไว้เช็คตอนที่มีการเปลี่ยนแปลก Panel 7
        let oForm = form.getValues();
        let isOtherBudget = oForm.isOtherBudget === "Y" ? true : false;

        let isWarning = false;
        let sWarning = "";
        let nWarning = 0;

        if (isWarning === false && arrProjectManage_Plan.filter(f => !f.isDelet).length === 0) {
            isWarning = true;
            nWarning = nWarning + 1;
            sWarning += "&nbsp;&nbsp; - กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ ในหัวข้อ งบบริหารโครงการ : กำหนดแผนงาน. <br/>";
        }
        if (isWarning === false && arrProjectManage_Activity.filter(f => !f.isDelet).length === 0) {
            isWarning = true;
            nWarning = nWarning + 1;
            sWarning += "&nbsp;&nbsp; - กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ ในหัวข้อ งบบริหารโครงการ : กำหนดกิจกรรม. <br/>";
        }
        if (isWarning === false && arrProjectManage_Plan.filter(f => !f.isDelete && f.isBtnDelete).length > 0) { //ต้องมีกิจกรรมในทุกแผนงานที่เพิ่มมาทั้งหมด
            isWarning = true;
            nWarning = nWarning + 1;
            sWarning += "&nbsp;&nbsp; - กรุณาเพิ่มข้อมูลกิจกรรมให้ครบทุกแผนงาน ในหัวข้อ งบบริหารโครงการ : กำหนดกิจกรรม. <br/>";
        }
        if (isWarning === false && arrProjectOperating_PlanActivity.filter(f => !f.isDelete && f.isSuccess === false).length > 0) {
            isWarning = true;
            nWarning = nWarning + 1;
            sWarning += "&nbsp;&nbsp; - กรุณาเพิ่มข้อมูลแผนงานให้ครบทุกแผนงาน ในหัวข้อ งบดำเนินงานโครงการ (แผนงาน/กิจกรรม). <br/>";
        }
        if (isWarning === false && isOtherBudget) //ช่วยเหลือ (ถ้ามี)
        {
            if (arrProjectHelp_Manage_Plan.filter(f => !f.isDelete && f.isBtnDelete).length > 0) {
                isWarning = true;
                nWarning = nWarning + 1;
                sWarning += "&nbsp;&nbsp; - กรุณาเพิ่มข้อมูลแผนงานให้ครบทุกแผนงาน ในหัวข้อ รายละเอียดความช่วยเหลือ (ถ้ามี) : งบบริหารโครงการ ส่วน กำหนดแผนงาน. <br/>";
            }
            if (arrProjectHelp_Operating_Plan.filter(f => !f.isDelete && f.isBtnDelete).length > 0) {
                isWarning = true;
                nWarning = nWarning + 1;
                sWarning += "&nbsp;&nbsp; - กรุณาเพิ่มข้อมูลแผนงานให้ครบทุกแผนงาน ในหัวข้อ รายละเอียดความช่วยเหลือ (ถ้ามี) : งบดำเนินงานโครงการ ส่วน กำหนดแผนงาน. <br/>";
            }
        }

        setObjCheckSubmitVersion({
            isPanel9: true,
            // sWarningPanel9: (isWarning === true ? "- กท 1 : 9. วงเงินงบประมาณ <br/>" + sWarning : null),
            sWarningPanel9: (isWarning === true ? (nWarning === 1 ? ("- กท 1 : 9. วงเงินงบประมาณ : " + sWarning.replace("&nbsp;&nbsp; -", "")) : ("- กท 1 : 9. วงเงินงบประมาณ <br/>" + sWarning)) : null),
            isWorkPlan: ObjCheckSubmitVersion?.isWorkPlan,
            sWarningWorkPlan: ObjCheckSubmitVersion?.sWarningWorkPlan,
            isSpendingPlan: ObjCheckSubmitVersion?.isSpendingPlan,
            sWarningSpendingPlan: ObjCheckSubmitVersion?.sWarningSpendingPlan,
        }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
    }

    return (
        <AccordionPanel
            header={"9. วงเงินงบประมาณ"}
            isExpanded={true}
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />
                )
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivPanel9"} item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                <Grid item xs={12} md={12} container spacing={2}>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item>
                            <Typography variant='h6' color={'#0000a5'}>วงเงินงบประมาณ</Typography>
                        </Grid>
                        <Grid item>
                            <Tooltip placement={'right-end'} title={"ระบุค่าใช้จ่ายทั้งหมดของโครงการที่ขอรับการสนับสนุนให้ชัดเจนโดยคำนึงถึงกากำหนดงบประมาณที่สมเหตุสมผล ถึงความประหยัดและคุ้มค่า โดยใช้เกณฑ์มาตรฐานราคากลางของสำนักงบ ประมาณเป็นหลัก ดังนี้"
                                + "๑) หลักกณฑ์ อัตราใช้จ่าย และแนวทางการพิจารณางบประมาณรายจ่ายประจำปีการฝึกอบรม สัมมนา การโฆษณา ประชาสัมพันธ์การจ้างที่ปรึกษา ค่าใช้จ่ายในการเดินทางไปราชการต่างประเทศ"
                                + "(สำนักงบประมาณ)"
                                + "๒) หลักเกณฑ์และอัตราค่าใช้จ่ายประกอบการพิจารณางบประมาณรายจ่ายประจำปีที่เบิกจ่ายในลักษณะค่าตอบแทน ใช้สอย วัสดุและค่าสาธารณุปโภค (สำนักงบประมาณ)"
                                + "ทั้งนี้ ให้ระบุงบประมาณที่ได้รับความช่วยเหลือจากแหล่งอื่น ๆ (ถ้ามิ)"}>
                                <ErrorIcon color='primary' />
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Divider />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"งบบริหารโครงการ"}
                            isExpanded={false}
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <Grid id={"myDiv_Manage_Plan"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                    <FormProvider {...formManage_Plan}>
                                        <Grid item xs={12} md={12} container spacing={2}>
                                            <Grid item>
                                                <Typography variant='h6' color={'#0000a5'}>กำหนดแผนงาน</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <TextBoxItem
                                                    id={"sManage_Plan"}
                                                    name={"sManage_Plan"}
                                                    type={"text"}
                                                    label={"ชื่อแผนงาน"}
                                                    required={true}
                                                    maxLength={500}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                                {(nProjectManage_PlanIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                    <BtnAdd id={"btnAdd_Table_Manage_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มแผนงาน"} onClick={formManage_Plan.handleSubmit((e) => onAddManage_Plan(), (err) => console.log("err", err))} />
                                                    :
                                                    <>
                                                        {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                            <Grid item>
                                                                <BtnSave id={"btnSave_Table_Manage_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formManage_Plan.handleSubmit((e) => onAddManage_Plan(), (err) => console.log("err", err))} />
                                                            </Grid>
                                                        }
                                                        {nProjectManage_PlanIDEdit !== 0 &&
                                                            <Grid item>
                                                                <BtnCancel id={"btnCancel_Table_Manage_Plan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectManage_PlanIDEdit(0); setObjManage_PlanIDEdit(null); onClearFieldManage_Plan(); }} />
                                                            </Grid>
                                                        }
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DataGrid
                                                sTableID='TB_ProjectManage_Plan'
                                                columns={dataColumnManage_Plan}
                                                rows={DataRowManage_Plan}
                                                isShowColomnTool={false}
                                                isHiddenToolHead={true}
                                                isShowCheckBox={false}
                                                isHiddenPagination={false}
                                            />
                                        </Grid>
                                    </FormProvider>
                                </Grid>
                                <Grid id={"myDiv_Manage_Activity"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                    <FormProvider {...formManage_Activity}>
                                        <Grid item xs={12} md={12} container spacing={2}>
                                            <Grid item>
                                                <Typography variant='h6' color={'#0000a5'}>กำหนดกิจกรรม</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                            <Grid item xs={12} md={12} container spacing={2}>
                                                <Grid item xs={12} md={12} container spacing={2}>
                                                    <Grid item xs={12} md={8}>
                                                        <SelectItem
                                                            id="nManage_PlanID"
                                                            name={"nManage_PlanID"}
                                                            label={"ชื่อแผนงาน"}
                                                            options={new LINQ<any>(arrProjectManage_Plan || []).Where(w => !w.isDelete).OrderBy(o => o.nOrder).Select(function (elem) { return { label: elem.nOrder + ". " + elem.sPlan, value: elem.nID, sPlan: elem.sPlan } }).ToArray()}
                                                            required={true}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <InputNumberItem
                                                            id={"nManage_FundBudget"}
                                                            name={"nManage_FundBudget"}
                                                            label={"งบกองทุนฯ (บาท)"}
                                                            IsComma={true}
                                                            IsAllowScientific={false}
                                                            type={"Number"}
                                                            ShowDigits={2}
                                                            maxDigits={2}
                                                            maxInteger={8}
                                                            endAdornment={"บาท"}
                                                            required={true}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        />
                                                        {/* <NumberInputCustom
                                                            id={"nManage_FundBudget"}
                                                            name={"nManage_FundBudget"}
                                                            label={"งบกองทุนฯ (บาท)"}
                                                            required={true}
                                                            IsAllowScientific={false}
                                                            maxDigits={2}
                                                            ShowDigits={2}
                                                            maxInteger={8}
                                                            maxLength={13}
                                                            IsCanMinus={false}
                                                            IsComma={true}
                                                            min={0}
                                                            endAdornment={"บาท"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        /> */}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <TextBoxItem
                                                        id={"sManage_Activity"}
                                                        name={"sManage_Activity"}
                                                        type={"text"}
                                                        label={"ชื่อกิจกรรม"}
                                                        required={true}
                                                        maxLength={500}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end" >
                                                {(nManage_ActivityIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                    <BtnAdd id={"btnAdd_Table_Manage_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มกิจกรรม"} onClick={formManage_Activity.handleSubmit((e) => onAddManage_Activity(), (err) => console.log("err", err))} />
                                                    :
                                                    <>
                                                        {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                            <Grid item>
                                                                <BtnSave id={"btnSave_Table_Manage_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formManage_Activity.handleSubmit((e) => onAddManage_Activity(), (err) => console.log("err", err))} />
                                                            </Grid>
                                                        }
                                                        {nManage_ActivityIDEdit !== 0 &&
                                                            <Grid item>
                                                                <BtnCancel id={"btnCancel_Table_Manage_Activity"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnManage_ActivityIDEdit(0); setObjManage_ActivityIDEdit(null); onClearFieldManage_Activity(); }} />
                                                            </Grid>
                                                        }
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                                            <CallTableManage_Activity />
                                        </Grid>
                                    </FormProvider>
                                </Grid>
                            </Grid>
                        </AccordionPanel>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"งบดำเนินงานโครงการ (แผนงาน/กิจกรรม)"}
                            isExpanded={false}
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formOperating}>
                                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                        {/* {nOperatingIDEdit !== 0 &&        
                                            <Grid item xs={12} md={12} container spacing={2}>                                
                                                <Grid item xs={12} md={12} container spacing={2}>
                                                    <Grid item xs={12} md={8}>                                                       
                                                        <Typography variant='body1'>{sOperating_Plan ? ("ชื่อแผนงาน: " + sOperating_Plan) : ""}</Typography>
                                                    </Grid>  
                                                    <Grid item xs={12} md={12}>
                                                        <TextAreaItem
                                                            id={"sOperating_ActivityDetail"}
                                                            name={"sOperating_ActivityDetail"}
                                                            label={"รายละเอียด"}
                                                            placeholder={"ระบุรายละเอียดเพิ่มเติม"}
                                                            required={true}
                                                            maxLength={500}
                                                            row={3}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        />
                                                    </Grid> 
                                                    <Grid item xs={12} md={5}>
                                                        <InputNumberItem
                                                            id={"sOperating_Budget"}
                                                            name={"sOperating_Budget"}
                                                            label={"งบกองทุนฯ (บาท)"}
                                                            placeholder={"ระบุงบประมาณ (บาท)"}
                                                            type={"Number"}
                                                            IsComma={true}
                                                            IsAllowScientific={false}
                                                            ShowDigits={2}
                                                            maxDigits={2}
                                                            endAdornment={"บาท"}
                                                            required={true}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                        />
                                                    </Grid>
                                                </Grid>  
                                                <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_Operating"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formOperating.handleSubmit((e) => onAddOperating(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Table_Operating"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnOperatingIDEdit(0); onClearFieldOperating(); }} />
                                                    </Grid>   
                                                </Grid>
                                            </Grid>          
                                        } */}
                                        <Grid item xs={12} md={12} container spacing={2}>
                                            <Grid item xs={12} md={8}>
                                                <SelectItem
                                                    id="nOperating_PlanID"
                                                    name={"nOperating_PlanID"}
                                                    label={"ชื่อแผนงาน"}
                                                    options={new LINQ<any>(arrProjectOperating_PlanActivity || []).OrderBy(o => o.nOrder).Select(function (elem) { return { label: "แผนงานที่ " + elem.nOrder + ". " + elem.sPlan, value: elem.nProjectPlanID, sPlan: elem.sPlan } }).ToArray()}
                                                    // required={true}                                                    
                                                    required={(isPermission && isModeSecretary !== true) ? true : (isEditSecretary === true ? true : false)}
                                                // disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            <Grid item>
                                                <Typography variant='body2' color={'red'}>หมายเหตุ : ข้อมูลมาจากการระบุหัวข้อ 7. แผนการดำเนินงาน</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                                            <CallTableOperating />
                                        </Grid>
                                        {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                                {!isEdit_Operating ?
                                                    <BtnAdd id={"btnAdd_Table_Operating"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มงบดำเนินงาน"} onClick={formOperating.handleSubmit((e) => onAddOperating(), (err) => console.log("err", err))} />
                                                    :
                                                    <>
                                                        <Grid item>
                                                            <BtnSave id={"btnSave_Table_Operating"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formOperating.handleSubmit((e) => onAddOperating(), (err) => console.log("err", err))} />
                                                        </Grid>
                                                        <Grid item>
                                                            <BtnCancel id={"btnCancel_Table_Operating"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnOperatingID(0); setisEdit_Operating(false); onClearFieldOperating(); }} />
                                                        </Grid>
                                                    </>
                                                }
                                            </Grid>
                                        }
                                    </Grid>
                                </FormProvider>
                            </Grid>
                        </AccordionPanel>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                        <AccordionPanel
                            header={"รายละเอียดความช่วยเหลือ"}
                            isExpanded={false}
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                            SubHeaderStatus={<Typography color={'#9f0000'}>{"(ถ้ามี)"}</Typography>}
                            sStyleSubHeader={"start"}
                        >
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...form}>
                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                        <RadioListItem
                                            id={"isOtherBudget"}
                                            name={"isOtherBudget"}
                                            label={""}
                                            IsNotShowLabel={true}
                                            required={true}
                                            options={arrTypeID}
                                            disabled={!isPermission || isEditSecretary === false}
                                        />
                                    </Grid>
                                    {form.watch("isOtherBudget") === "Y" &&
                                        <Grid item xs={12} md={12} container spacing={2}> {/* style={{ display: (form.watch("isOtherBudget") === "Y" ? "" : "none"), }} */}
                                            <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                                <TextBoxItem
                                                    id={"sOtherBudgetUnit"}
                                                    name={"sOtherBudgetUnit"}
                                                    type={"text"}
                                                    label={"ความช่วยเหลือจาก"}
                                                    placeholder={"ระบุชื่่อหน่วยงานอื่น"}
                                                    required={form.watch("isOtherBudget") === "Y"}
                                                    maxLength={500}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={2}>
                                                <AccordionPanel
                                                    header={"งบบริหารโครงการ"}
                                                    isExpanded={false}
                                                    color="white"
                                                    bgColor="rgb(102,151,245)"
                                                    background="#e79a09"
                                                    expandIconColor="white"
                                                    borderColor="1px solid #e79a09"
                                                    borderRadius="20px !important"
                                                    boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                                    boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                                                >
                                                    <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                                        <Grid id={"myDiv_Help_Manage_Plan"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                            <FormProvider {...formHelp_Manage_Plan}>
                                                                <Grid item xs={12} md={12} container spacing={2}>
                                                                    <Grid item>
                                                                        <Typography variant='h6' color={'#0000a5'}>กำหนดแผนงาน</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12}>
                                                                        <Divider />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12} container spacing={2}>
                                                                    <Grid item xs={12} md={12}>
                                                                        <TextBoxItem
                                                                            id={"sHelp_Manage_Plan"}
                                                                            name={"sHelp_Manage_Plan"}
                                                                            type={"text"}
                                                                            label={"ชื่อแผนงาน"}
                                                                            required={true}
                                                                            maxLength={500}
                                                                            disabled={!isPermission || isEditSecretary === false}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                                                        {(nProjectHelp_Manage_PlanIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                                            <BtnAdd id={"btnAdd_Table_Help_Manage_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มแผนงาน"} onClick={formHelp_Manage_Plan.handleSubmit((e) => onAddHelp_Manage_Plan(), (err) => console.log("err", err))} />
                                                                            :
                                                                            <>
                                                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                                                    <Grid item>
                                                                                        <BtnSave id={"btnSave_Table_Help_Manage_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formHelp_Manage_Plan.handleSubmit((e) => onAddHelp_Manage_Plan(), (err) => console.log("err", err))} />
                                                                                    </Grid>
                                                                                }
                                                                                {nProjectHelp_Manage_PlanIDEdit !== 0 &&
                                                                                    <Grid item>
                                                                                        <BtnCancel id={"btnCancel_Table_Help_Manage_Plan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectHelp_Manage_PlanIDEdit(0); setObjHelp_Manage_PlanIDEdit(null); onClearFieldHelp_Manage_Plan(); }} />
                                                                                    </Grid>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12}>
                                                                    <DataGrid
                                                                        sTableID='TB_ProjectHelp_Manage_Plan'
                                                                        columns={dataColumnHelp_Manage_Plan}
                                                                        rows={DataRowHelp_Manage_Plan}
                                                                        isShowColomnTool={false}
                                                                        isHiddenToolHead={true}
                                                                        isShowCheckBox={false}
                                                                        isHiddenPagination={false}
                                                                    />
                                                                </Grid>
                                                            </FormProvider>
                                                        </Grid>
                                                        <Grid id={"myDiv_Help_Manage_Activity"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                            <FormProvider {...formHelp_Manage_Activity}>
                                                                <Grid item xs={12} md={12} container spacing={2}>
                                                                    <Grid item>
                                                                        <Typography variant='h6' color={'#0000a5'}>กำหนดกิจกรรม</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12}>
                                                                        <Divider />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                                    <Grid item xs={12} md={12} container spacing={2}>
                                                                        <Grid item xs={12} md={12} container spacing={2}>
                                                                            <Grid item xs={12} md={8}>
                                                                                <SelectItem
                                                                                    id="nHelp_Manage_PlanID"
                                                                                    name={"nHelp_Manage_PlanID"}
                                                                                    label={"ชื่อแผนงาน"}
                                                                                    options={new LINQ<any>(arrProjectHelp_Manage_Plan || []).Where(w => !w.isDelete).OrderBy(o => o.nOrder).Select(function (elem) { return { label: elem.nOrder + ". " + elem.sPlan, value: elem.nID, sPlan: elem.sPlan } }).ToArray()}
                                                                                    required={true}
                                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={4}>
                                                                                <InputNumberItem
                                                                                    id={"nHelp_Manage_FundBudget"}
                                                                                    name={"nHelp_Manage_FundBudget"}
                                                                                    label={"งบสนับสนุนจากหน่วยงานอื่น (บาท)"}
                                                                                    IsComma={true}
                                                                                    IsAllowScientific={false}
                                                                                    type={"Number"}
                                                                                    ShowDigits={2}
                                                                                    maxDigits={2}
                                                                                    maxInteger={8}
                                                                                    endAdornment={"บาท"}
                                                                                    required={true}
                                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                                />
                                                                                {/* <NumberInputCustom
                                                                                    id={"nHelp_Manage_FundBudget"}
                                                                                    name={"nHelp_Manage_FundBudget"}
                                                                                    label={"งบสนับสนุนจากหน่วยงานอื่น (บาท)"}
                                                                                    required={true}
                                                                                    IsAllowScientific={false}
                                                                                    maxDigits={2}
                                                                                    ShowDigits={2}
                                                                                    maxInteger={8}
                                                                                    maxLength={13}
                                                                                    IsCanMinus={false}
                                                                                    IsComma={true}
                                                                                    min={0}
                                                                                    endAdornment={"บาท"}
                                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                                /> */}
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={12} md={12}>
                                                                            <TextBoxItem
                                                                                id={"sHelp_Manage_Activity"}
                                                                                name={"sHelp_Manage_Activity"}
                                                                                type={"text"}
                                                                                label={"ชื่อกิจกรรม"}
                                                                                required={true}
                                                                                maxLength={500}
                                                                                disabled={!isPermission || isEditSecretary === false}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end" >
                                                                        {(nHelp_Manage_ActivityIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                                            <BtnAdd id={"btnAdd_Table_Help_Manage_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มกิจกรรม"} onClick={formHelp_Manage_Activity.handleSubmit((e) => onAddHelp_Manage_Activity(), (err) => console.log("err", err))} />
                                                                            :
                                                                            <>
                                                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                                                    <Grid item>
                                                                                        <BtnSave id={"btnSave_Table_Help_Manage_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formHelp_Manage_Activity.handleSubmit((e) => onAddHelp_Manage_Activity(), (err) => console.log("err", err))} />
                                                                                    </Grid>
                                                                                }
                                                                                {nHelp_Manage_ActivityIDEdit !== 0 &&
                                                                                    <Grid item>
                                                                                        <BtnCancel id={"btnCancel_Table_Help_Manage_Activity"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnHelp_Manage_ActivityIDEdit(0); setObjHelp_Manage_ActivityIDEdit(null); onClearFieldHelp_Manage_Activity(); }} />
                                                                                    </Grid>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                                                                    <CallTableHelp_Manage_Activity />
                                                                </Grid>
                                                            </FormProvider>
                                                        </Grid>
                                                    </Grid>
                                                </AccordionPanel>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                <AccordionPanel
                                                    header={"งบดำเนินงานโครงการ (แผนงาน/กิจกรรม)"}
                                                    isExpanded={false}
                                                    color="white"
                                                    bgColor="rgb(102,151,245)"
                                                    background="#e79a09"
                                                    expandIconColor="white"
                                                    borderColor="1px solid #e79a09"
                                                    borderRadius="20px !important"
                                                    boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                                    boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                                                >
                                                    <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                                        <Grid id={"myDiv_Help_Operating_Plan"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                            <FormProvider {...formHelp_Operating_Plan}>
                                                                <Grid item xs={12} md={12} container spacing={2}>
                                                                    <Grid item>
                                                                        <Typography variant='h6' color={'#0000a5'}>กำหนดแผนงาน</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12}>
                                                                        <Divider />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12} container spacing={2}>
                                                                    <Grid item xs={12} md={12}>
                                                                        <TextBoxItem
                                                                            id={"sHelp_Operating_Plan"}
                                                                            name={"sHelp_Operating_Plan"}
                                                                            type={"text"}
                                                                            label={"ชื่อแผนงาน"}
                                                                            required={true}
                                                                            maxLength={500}
                                                                            disabled={!isPermission || isEditSecretary === false}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                                                        {(nProjectHelp_Operating_PlanIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                                            <BtnAdd id={"btnAdd_Table_Help_Operating_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มแผนงาน"} onClick={formHelp_Operating_Plan.handleSubmit((e) => onAddHelp_Operating_Plan(), (err) => console.log("err", err))} />
                                                                            :
                                                                            <>
                                                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                                                    <Grid item>
                                                                                        <BtnSave id={"btnSave_Table_Help_Operating_Plan"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formHelp_Operating_Plan.handleSubmit((e) => onAddHelp_Operating_Plan(), (err) => console.log("err", err))} />
                                                                                    </Grid>
                                                                                }
                                                                                {nProjectHelp_Operating_PlanIDEdit !== 0 &&
                                                                                    <Grid item>
                                                                                        <BtnCancel id={"btnCancel_Table_Help_Operating_Plan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectHelp_Operating_PlanIDEdit(0); setObjHelp_Operating_PlanIDEdit(null); onClearFieldHelp_Operating_Plan(); }} />
                                                                                    </Grid>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12}>
                                                                    <DataGrid
                                                                        sTableID='TB_ProjectHelp_Operating_Plan'
                                                                        columns={dataColumnHelp_Operating_Plan}
                                                                        rows={DataRowHelp_Operating_Plan}
                                                                        isShowColomnTool={false}
                                                                        isHiddenToolHead={true}
                                                                        isShowCheckBox={false}
                                                                        isHiddenPagination={false}
                                                                    />
                                                                </Grid>
                                                            </FormProvider>
                                                        </Grid>
                                                        <Grid id={"myDiv_Help_Operating_Activity"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                            <FormProvider {...formHelp_Operating_Activity}>
                                                                <Grid item xs={12} md={12} container spacing={2}>
                                                                    <Grid item>
                                                                        <Typography variant='h6' color={'#0000a5'}>กำหนดกิจกรรม</Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12}>
                                                                        <Divider />
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                                                                    <Grid item xs={12} md={12} container spacing={2}>
                                                                        <Grid item xs={12} md={12} container spacing={2}>
                                                                            <Grid item xs={12} md={8}>
                                                                                <SelectItem
                                                                                    id="nHelp_Operating_PlanID"
                                                                                    name={"nHelp_Operating_PlanID"}
                                                                                    label={"ชื่อแผนงาน"}
                                                                                    options={new LINQ<any>(arrProjectHelp_Operating_Plan || []).Where(w => !w.isDelete).OrderBy(o => o.nOrder).Select(function (elem) { return { label: elem.nOrder + ". " + elem.sPlan, value: elem.nID, sPlan: elem.sPlan } }).ToArray()}
                                                                                    required={true}
                                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={4}>
                                                                                <InputNumberItem
                                                                                    id={"nHelp_Operating_FundBudget"}
                                                                                    name={"nHelp_Operating_FundBudget"}
                                                                                    label={"งบสนับสนุนจากหน่วยงานอื่น (บาท)"}
                                                                                    IsComma={true}
                                                                                    IsAllowScientific={false}
                                                                                    type={"Number"}
                                                                                    ShowDigits={2}
                                                                                    maxDigits={2}
                                                                                    maxInteger={8}
                                                                                    endAdornment={"บาท"}
                                                                                    required={true}
                                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                                />
                                                                                {/* <NumberInputCustom
                                                                                    id={"nHelp_Operating_FundBudget"}
                                                                                    name={"nHelp_Operating_FundBudget"}
                                                                                    label={"งบสนับสนุนจากหน่วยงานอื่น (บาท)"}
                                                                                    required={true}
                                                                                    IsAllowScientific={false}
                                                                                    maxDigits={2}
                                                                                    ShowDigits={2}
                                                                                    maxInteger={8}
                                                                                    IsCanMinus={false}
                                                                                    IsComma={true}
                                                                                    min={0}
                                                                                    endAdornment={"บาท"}
                                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                                /> */}
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={12} md={12}>
                                                                            <TextBoxItem
                                                                                id={"sHelp_Operating_Activity"}
                                                                                name={"sHelp_Operating_Activity"}
                                                                                type={"text"}
                                                                                label={"ชื่อกิจกรรม"}
                                                                                required={true}
                                                                                maxLength={500}
                                                                                disabled={!isPermission || isEditSecretary === false}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end" >
                                                                        {(nHelp_Operating_ActivityIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                                            <BtnAdd id={"btnAdd_Table_Help_Operating_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มกิจกรรม"} onClick={formHelp_Operating_Activity.handleSubmit((e) => onAddHelp_Operating_Activity(), (err) => console.log("err", err))} />
                                                                            :
                                                                            <>
                                                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                                                    <Grid item>
                                                                                        <BtnSave id={"btnSave_Table_Help_Operating_Activity"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formHelp_Operating_Activity.handleSubmit((e) => onAddHelp_Operating_Activity(), (err) => console.log("err", err))} />
                                                                                    </Grid>
                                                                                }
                                                                                {nHelp_Operating_ActivityIDEdit !== 0 &&
                                                                                    <Grid item>
                                                                                        <BtnCancel id={"btnCancel_Table_Help_Operating_Activity"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnHelp_Operating_ActivityIDEdit(0); setObjHelp_Operating_ActivityIDEdit(null); onClearFieldHelp_Operating_Activity(); }} />
                                                                                    </Grid>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                                                                    <CallTableHelp_Operating_Activity />
                                                                </Grid>
                                                            </FormProvider>
                                                        </Grid>
                                                    </Grid>
                                                </AccordionPanel>
                                            </Grid>
                                        </Grid>
                                    }
                                </FormProvider>
                            </Grid>
                        </AccordionPanel>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%', paddingBottom: '1%', }}>
                        <CallTableSummary />
                    </Grid>
                    {nProjectID === 0 || (nStatusID === EnumProjectStatusID.nStatusID_11 && nLogChangeID === null) ?
                        <></>
                        :
                        (isPermission === true &&
                            (isModeSecretary !== true ?
                                <Grid item xs={12} md={12} container spacing={1} justifyContent="end" style={{ paddingBottom: '1%', }}>
                                    {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                        <Grid item>
                                            <BtnDraft id={"btnDraft_Panel9"} IsDisabled={isError} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                        </Grid>
                                    }
                                    <Grid item>
                                        <BtnSendRequest id={"btnSend_Panel9"} IsDisabled={isError} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                    </Grid>
                                </Grid>
                                :
                                (isModeSecretary === true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {isEditSecretary === false ?
                                            <Grid item>
                                                <BtnEdit id={"btnEdit_Panel9"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel9").scrollIntoView({ behavior: "smooth" }); }} />
                                            </Grid>
                                            :
                                            <>
                                                <Grid item>
                                                    <BtnCancel id={"btnCancel_Panel9"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                </Grid>
                                                <Grid item>
                                                    <BtnSendRequest id={"btnSend_Panel9"} IsDisabled={isError} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                    : <></>
                                )
                            )
                        )
                    }
                    <Grid item style={{ display: 'none' }}>
                        <BtnSendRequest id={"btnCheck_Panel9_ChangeStatus"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { CheckSubmitProjectChangeStatus(); }} />
                    </Grid>
                </Grid>
            </Grid>
        </AccordionPanel>
    )
}
export default Panel9;
